// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `textarea:focus,
input:focus,
a:focus,
a:hover:focus,
button:focus,
.btn.focus,
.btn:focus,
.astm-btn:focus {
  outline: none !important;
  box-shadow: none !important;
}

.modal-body .invalid-feedback {
  display: block;
}

div#deleteModal,
#itemNumberModal {
  background: rgba(0, 0, 0, 0.4);
}

.logoWrap a img {
  height: 57px;
}

.mr16 {
  margin-right: 16px !important;
}

header .topMenuBar .menuWrapper {
  flex-grow: inherit;
  justify-content: flex-start !important;
}
header .topMenuBar .menuWrapper a {
  padding: 20px 0 18px;
}
header .topMenuBar .menuWrapper .dropdown-item {
  text-decoration: none;
  padding: 0.5rem 1.5rem;
}

.dropdown-item {
  padding: 0.5rem 1.5rem !important;
}

.dropdown-item:focus,
.dropdown-item:hover {
  padding: 0.5rem 1.5rem;
}

.breadcrumb-wrapper {
  z-index: 9;
  position: fixed;
  top: 144px;
  background: #fff;
  width: 100%;
  font-family: "Proxima Nova", sans-serif;
}

.middle-container {
  position: relative;
  margin-top: 125px;
  height: calc(100vh - 270px);
}
.middle-container .leftMenuSection {
  width: 255px;
  padding: 0;
  border-right: 1px solid rgb(221, 221, 221);
  position: absolute;
  left: 0;
  top: 0px;
  min-height: calc(100vh - 270px);
  transition: 0.5s;
}
.middle-container .leftMenuSection ul {
  list-style: none;
  margin: 0;
  padding: 16px 0 0 0;
}
.middle-container .leftMenuSection ul li a {
  display: flex;
  align-items: center;
  color: rgb(0, 93, 164);
  padding: 16px 0;
  font-size: 14px;
  white-space: nowrap;
  padding-left: 15px;
  border-radius: 4px 0 0 4px;
  position: relative;
}
.middle-container .leftMenuSection ul li a:hover {
  text-decoration: none;
  background: rgba(35, 47, 58, 0.06);
}
.middle-container .leftMenuSection ul li a span.menu-ic {
  width: 28px;
}
.middle-container .leftMenuSection ul li a span.menu-ic .collabration-ic {
  position: relative;
  left: -2px;
}
.middle-container .leftMenuSection ul li a svg {
  margin-right: 14px;
  margin-bottom: 0;
  color: #232f3a;
  position: relative;
  top: -2px;
}
.middle-container .leftMenuSection ul li a span.menu-name {
  white-space: nowrap;
  font-size: 14px !important;
}
.middle-container .leftMenuSection ul li a .custom-tool-tip {
  display: none;
}
.middle-container .leftMenuSection ul li a.active {
  text-decoration: none;
  background: rgba(35, 47, 58, 0.06);
  color: #232f3a;
}
.middle-container .leftMenuSection ul li .inner-sub-menu li a {
  padding: 14px 14px;
  border-radius: 4px 0px 0px 4px;
}
.middle-container .leftMenuSection ul li .inner-sub-menu li a:hover {
  text-decoration: none;
  background: rgb(244, 244, 245);
}
.middle-container .leftMenuSection .document-menu-sec > a {
  display: flex;
  align-items: center;
  color: rgb(0, 93, 164);
  padding: 16px 0;
  font-size: 14px;
  white-space: nowrap;
  padding-left: 15px;
  border-radius: 4px 0 0 4px;
  pointer-events: none;
}
.middle-container .leftMenuSection .document-menu-sec > a .menu-name {
  font-size: 14px;
}
.middle-container .leftMenuSection .document-menu-sec > a:hover {
  text-decoration: none;
}
.middle-container .leftMenuSection .document-menu-sec > a svg {
  margin-right: 14px;
  margin-bottom: 0;
  color: #232f3a;
  position: relative;
  top: -2px;
}
.middle-container .leftMenuSection .document-menu-sec a.active {
  text-decoration: none;
  background: rgba(35, 47, 58, 0.06);
  color: #232f3a;
}
.middle-container .leftMenuSection .custom-tool-tip {
  display: none;
}
.middle-container .leftMenuSection button.btn.toggle-Btn {
  position: absolute;
  top: 25px;
  right: -15px;
  background: #fff;
  border-radius: 100%;
  border: 1px solid #f1f1f1;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 91;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1) !important;
}
.middle-container .leftMenuSection button.btn.toggle-Btn i {
  color: rgba(35, 47, 58, 0.5);
  position: relative;
  top: -1px;
}
.middle-container .leftMenuSection button.btn.toggle-Btn i::before {
  font-size: 13px;
}
.middle-container .leftMenuSection .toggle-Btn.removeSidebarToggleIcon {
  display: none !important;
}
.middle-container .leftMenuSection ul.inner-sub-menu {
  padding-left: 30px;
  padding-top: 0;
}
.middle-container .rightSectionWrap {
  position: relative;
  width: calc(100% - 255px);
  margin-left: 255px;
  padding: 20px 0 0 0;
  transition: 0.5s;
  height: 100%;
}
.middle-container .rightSectionWrap .custom-scrollbar {
  padding: 0px 10px 10px 25px;
  height: 100%;
}
.middle-container .rightSectionWrap .failure-info-section {
  background: #fef9ea;
  border: 1px solid #fef4d5;
  margin: 0;
  padding: 20px;
}
.middle-container .rightSectionWrap .failure-info-section .heading-panel {
  display: flex;
}
.middle-container .rightSectionWrap .failure-info-section .heading-panel svg {
  margin-right: 8px;
  display: inline-block;
}
.middle-container .rightSectionWrap .failure-info-section .heading-panel p {
  color: #7e6417;
  font-size: 14px;
  line-height: 16px;
  font-family: Proxima Nova, sans-serif;
}
.middle-container .rightSectionWrap .failure-info-section ul {
  margin: 0;
  padding: 0 0 0 20px;
}
.middle-container .rightSectionWrap .failure-info-section ul li {
  padding: 0;
  margin: 0;
  color: #7e6417;
  font-size: 14px;
  line-height: 16px;
  font-family: Proxima Nova, sans-serif;
}
.middle-container .rightSectionWrap .failure-info-section .btm-action-btns {
  margin-top: 16px;
}
.middle-container .rightSectionWrap .top-header.custom-top-position {
  position: static;
  width: 100%;
  margin-top: 20px;
  padding: 0;
}
.middle-container .rightSectionWrap .top-header.custom-top-position.ballotFixedHeader {
  position: absolute;
  width: calc(100% - 40px);
  background: #fff;
  top: 20px;
  padding: 0 0 10px 0;
  margin: 0;
}

.custom-scrollbar.remove-scroll {
  overflow: hidden;
}

.middle-container.remove-sidebar .leftMenuSection {
  width: 60px;
}
.middle-container.remove-sidebar .leftMenuSection ul {
  margin-right: 30px;
  width: calc(100% - 20px);
}
.middle-container.remove-sidebar .leftMenuSection ul li {
  margin-top: 5px;
}
.middle-container.remove-sidebar .leftMenuSection ul li a {
  width: 36px;
  height: 42px;
  display: flex;
  justify-content: center;
  padding: 0;
  border-radius: 4px;
  position: relative;
}
.middle-container.remove-sidebar .leftMenuSection ul li a svg {
  margin: 0;
  padding: 10px;
  width: 36px;
  height: 36px;
}
.middle-container.remove-sidebar .leftMenuSection ul li a .custom-tool-tip {
  display: block;
}
.middle-container.remove-sidebar .leftMenuSection ul li a .menu-ic {
  display: none;
}
.middle-container.remove-sidebar .leftMenuSection .document-menu-sec .menu-ic.document-ic {
  display: none;
}
.middle-container.remove-sidebar .leftMenuSection .document-menu-sec a {
  width: 36px;
  border-radius: 4px;
  height: 36px;
  padding-left: 8px;
}
.middle-container.remove-sidebar .leftMenuSection .document-menu-sec a span.menu-ic.document-ic {
  width: 20px;
}
.middle-container.remove-sidebar .leftMenuSection .document-menu-sec a .custom-tool-tip {
  display: block;
}
.middle-container.remove-sidebar .leftMenuSection .document-menu-sec a .custom-tool-tip svg {
  padding: 10px;
}
.middle-container.remove-sidebar .leftMenuSection .document-menu-sec a .custom-tool-tip.doc-big-ic svg {
  padding: 0 6px 0 0;
  left: 0px;
}
.middle-container.remove-sidebar .leftMenuSection span.menu-name {
  visibility: hidden;
  display: none;
}
.middle-container.remove-sidebar .leftMenuSection ul.inner-sub-menu {
  padding-left: 0px;
}
.middle-container.remove-sidebar .leftMenuSection ul.inner-sub-menu li a {
  padding: 14px 0;
  width: 36px;
  height: 36px;
  display: flex;
  justify-content: center;
  border-radius: 4px;
  margin-bottom: 5px;
}
.middle-container.remove-sidebar .leftMenuSection ul.inner-sub-menu li a svg {
  margin: 0;
  padding: 0;
}
.middle-container.remove-sidebar .leftMenuSection button.btn.toggle-Btn i {
  rotate: 180deg;
  position: relative;
  left: 2px;
  top: 2px;
}

.middle-container.remove-sidebar .rightSectionWrap {
  position: relative;
  width: calc(100% - 70px);
  margin-left: 70px;
}
.middle-container.remove-sidebar .rightSectionWrap .custom-scrollbar {
  padding: 0px 10px 25px 0px;
}
.middle-container.remove-sidebar .rightSectionWrap .custom-scrollbar .listing-filter-sec {
  padding-left: 20px;
}
.middle-container.remove-sidebar .rightSectionWrap .ballot-queue-table-wrapper tr th:nth-child(5) .table-heading-text {
  text-overflow: unset;
  white-space: nowrap;
  overflow: unset;
  display: inline-block;
  width: auto;
}
.middle-container.remove-sidebar .rightSectionWrap .ballot-queue-table-wrapper tr th:nth-child(6) .table-heading-text {
  display: inline-block;
  width: auto;
}
.middle-container.remove-sidebar .rightSectionWrap .litigation-header {
  width: calc(100% - 16px);
  left: 0;
}
.middle-container.remove-sidebar .rightSectionWrap .main-ballot-wrapper .top-search-Ballot-wrapper {
  width: calc(100% - 6px);
  left: 0;
  padding: 0 10px 10px 15px;
}
.middle-container.remove-sidebar .rightSectionWrap .main-ballot-wrapper .ballot-list-wrap {
  padding-left: 15px;
}
.middle-container.remove-sidebar .rightSectionWrap .litigation-wrapper .litigation-header {
  width: calc(100% - 6px);
  left: 0;
  padding: 0 10px 10px 15px;
}
.middle-container.remove-sidebar .rightSectionWrap .table-filter-listing {
  padding-left: 15px;
}

.middle-container.remove-sidebar .ballot-detail-wrapper {
  padding-left: 20px;
}
.middle-container.remove-sidebar .ballot-detail-wrapper .btm-placement {
  position: absolute;
  left: 100px;
  top: 38px;
}
.middle-container.remove-sidebar .ballot-detail-wrapper .zip-txt.btm-zip-placement {
  position: absolute;
  left: 220px;
  top: 40px;
}
.middle-container.remove-sidebar .ballot-detail-wrapper .top-header {
  left: 20px;
  padding-bottom: 28px;
}
.middle-container.remove-sidebar .ballot-detail-wrapper .top-header.custom-top-position {
  top: 245px;
}
.middle-container.remove-sidebar .ballot-detail-wrapper.sequence-Committee-Wrapper .top-header {
  padding-bottom: 0;
}
.middle-container.remove-sidebar .ballot-detail-wrapper.failed-panel-wrapper .top-left-sec {
  position: relative;
}
.middle-container.remove-sidebar .ballot-detail-wrapper.failed-panel-wrapper .btm-placement {
  position: absolute;
  left: 100px;
  top: 34px;
}
.middle-container.remove-sidebar .ballot-detail-wrapper.failed-panel-wrapper .top-header {
  padding-bottom: 10px;
  top: 20px;
}
.middle-container.remove-sidebar .ballot-detail-wrapper.failed-panel-wrapper .top-header.custom-top-position.ballotFixedHeader {
  padding-bottom: 25px;
  width: calc(100% - 35px);
}
.middle-container.remove-sidebar .rightSectionWrap.adjust-rightSectionWrap .ballot-queue-table-wrapper th:nth-child(5) .table-heading-text {
  width: 42px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  display: inline-block;
}

.rightSectionWrap.adjust-rightSectionWrap {
  width: calc(100% - 410px) !important;
}
.rightSectionWrap.adjust-rightSectionWrap table thead tr th:nth-child(3) .table-heading-text,
.rightSectionWrap.adjust-rightSectionWrap table thead tr th:nth-child(4) .table-heading-text,
.rightSectionWrap.adjust-rightSectionWrap table thead tr th:nth-child(5) .table-heading-text,
.rightSectionWrap.adjust-rightSectionWrap table thead tr th:nth-child(6) .table-heading-text {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  display: inline-block;
  width: 60px;
}
.rightSectionWrap.adjust-rightSectionWrap .ballot-queue-table-wrapper td {
  word-break: break-word;
}
.rightSectionWrap.adjust-rightSectionWrap .ballot-queue-table-wrapper th:nth-child(2) .table-heading-text {
  width: auto;
}
.rightSectionWrap.adjust-rightSectionWrap .ballot-queue-table-wrapper th:nth-child(3) .table-heading-text {
  width: 40px;
}
.rightSectionWrap.adjust-rightSectionWrap .ballot-queue-table-wrapper th:nth-child(4) .table-heading-text {
  width: 40px;
}
.rightSectionWrap.adjust-rightSectionWrap .ballot-queue-table-wrapper th:nth-child(5) .table-heading-text {
  width: 42px;
}
.rightSectionWrap.adjust-rightSectionWrap .ballot-queue-table-wrapper th:nth-child(6) .table-heading-text {
  width: 50px;
}
.rightSectionWrap.adjust-rightSectionWrap .ballot-queue-table-wrapper th:nth-child(7) .table-heading-text {
  width: 50px;
}
.rightSectionWrap.adjust-rightSectionWrap .ballot-queue-table-wrapper .table-heading-text {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  display: inline-block;
}
.rightSectionWrap.adjust-rightSectionWrap .ballot-queue-table-wrapper .td-col-one {
  width: 140px;
}
.rightSectionWrap.adjust-rightSectionWrap table.collaboration-wrapper th:nth-child(2) {
  width: 230px;
}
.rightSectionWrap.adjust-rightSectionWrap table.collaboration-wrapper .td-col-one {
  width: 200px;
}
.rightSectionWrap.adjust-rightSectionWrap .table-filter-listing table.collaboration-wrapper td:nth-child(2) {
  width: 230px;
}
.rightSectionWrap.adjust-rightSectionWrap .table-filter-listing table.collaboration-wrapper th:nth-child(5) .table-heading-text {
  text-overflow: unset;
  width: auto;
}
.rightSectionWrap.adjust-rightSectionWrap table.ballot-items-table-wrapper thead tr th:nth-child(3) .table-heading-text,
.rightSectionWrap.adjust-rightSectionWrap table.ballot-items-table-wrapper thead tr th:nth-child(4) .table-heading-text,
.rightSectionWrap.adjust-rightSectionWrap table.ballot-items-table-wrapper thead tr th:nth-child(5) .table-heading-text,
.rightSectionWrap.adjust-rightSectionWrap table.ballot-items-table-wrapper thead tr th:nth-child(6) .table-heading-text,
.rightSectionWrap.adjust-rightSectionWrap table.ballot-items-table-wrapper thead tr th:nth-child(7) .table-heading-text {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  display: inline-block;
  width: 40px;
  vertical-align: bottom;
}
.rightSectionWrap.adjust-rightSectionWrap table.ballot-items-table-wrapper tbody tr td .indicator-container button {
  width: 90px;
  display: inline-block;
  word-break: break-word;
  white-space: normal;
}
.rightSectionWrap.adjust-rightSectionWrap .listing-filter-sec .custom-search-wrapper .seach-box-sec {
  width: 338px;
}
.rightSectionWrap.adjust-rightSectionWrap .td-col-one {
  width: 180px;
}
.rightSectionWrap.adjust-rightSectionWrap .closing-reports-wrapper th.pointer {
  padding-right: 20px;
}
.rightSectionWrap.adjust-rightSectionWrap .closing-reports-wrapper .td-col-one {
  width: 130px;
}
.rightSectionWrap.adjust-rightSectionWrap .flex-box label {
  display: none;
}
.rightSectionWrap.adjust-rightSectionWrap .astm-table thead tr th.pointer {
  padding-right: 30px;
}
.rightSectionWrap.adjust-rightSectionWrap .astm-table.closing-reports-wrapper thead tr th.pointer {
  padding-right: 20px;
}
.rightSectionWrap.adjust-rightSectionWrap .custom-scrollbar {
  padding-left: 5px;
}
.rightSectionWrap.adjust-rightSectionWrap .listing-filter-sec {
  padding-left: 5px;
}
.rightSectionWrap.adjust-rightSectionWrap .listing-filter-sec .vote-search-box {
  max-width: 520px;
}
.rightSectionWrap.adjust-rightSectionWrap .listing-filter-sec .vote-search-box .input-Box.ballot-seach {
  width: 260px;
}
.rightSectionWrap.adjust-rightSectionWrap .closing-reports-wrapper .td-col-one {
  width: 240px;
}

ul.inner-sub-menu.remove-inner-sidebar {
  display: none;
}

.fa-asterisk.disabled-star {
  margin-right: 0 !important;
  width: 10px;
  position: relative;
  top: -5px;
}
.fa-asterisk.disabled-star::before {
  font-size: 6px;
  color: #71777f;
}

.mt24 {
  margin-top: 24px;
}

.mb24 {
  margin-bottom: 24px;
}

.mtb24 {
  margin-top: 24px;
  margin-bottom: 24px;
}

.h-145 {
  height: 145px !important;
}

.small-txt-info {
  position: absolute;
  bottom: -3px;
}

.tooltip .tooltip-inner {
  max-width: 200px !important;
  position: relative;
}
.tooltip .tooltip-inner::before {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 8px solid #303030;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
}

.tooltip.custom-tooltip-panel .tooltip-inner {
  max-width: 280px !important;
  position: relative;
}

.CustomLoader {
  position: absolute;
  left: 60%;
  top: 65%;
  transform: translate(-50%, -50%);
  z-index: 999;
}

.custom-scrollbar {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: calc(100vh - 280px);
}

#scroll-bar::-webkit-scrollbar-track,
.ballot-list-wrap::-webkit-scrollbar-track {
  border-radius: 4px;
  background-color: #e7e7e7;
}

#scroll-bar::-webkit-scrollbar,
.ballot-list-wrap::-webkit-scrollbar {
  width: 6px;
  background-color: #cccccc;
}

#scroll-bar::-webkit-scrollbar-thumb,
.ballot-list-wrap::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: #cfcfcf;
}

.profileOptionMenu.dropdown .dropdown-menu {
  inset: 0px -1px auto auto !important;
}

.profileOptionMenu.dropdown .btn-success:not(:disabled):not(.disabled).active,
.profileOptionMenu.dropdown .btn-success:not(:disabled):not(.disabled):active,
.profileOptionMenu.dropdown .show > .btn-success.dropdown-toggle {
  color: #232f3a !important;
  background-color: #fdc92f !important;
  border-color: #fdc92f !important;
}

.Upload-sec-wrapper {
  padding-left: 10px;
  padding-right: 10px;
}
.Upload-sec-wrapper .character-limt-txt {
  text-align: right;
  margin-top: 8px;
}
.Upload-sec-wrapper .form-group.status-dropdown select {
  position: relative;
  top: -1px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.Upload-sec-wrapper .darg-drop-box input {
  opacity: 0;
  width: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  height: 100%;
  cursor: pointer;
}
.Upload-sec-wrapper .darg-drop-box .upload-txt {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 0;
}
.Upload-sec-wrapper .darg-drop-box .upload-txt span {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
}
.Upload-sec-wrapper .custom-flex {
  height: 100%;
  display: flex;
  align-items: center;
  margin-top: -1px;
}
.Upload-sec-wrapper .errorMessage {
  background: #f4e9ea;
  display: inline-block;
  padding: 0.75rem 1.25rem;
  border-radius: 4px;
  margin-right: 15px;
  border: 1px solid #ebd6d8;
  color: #841b24;
}
.Upload-sec-wrapper .errorMessage .invalid-icon {
  margin-right: 8px;
  position: relative;
  top: -1px;
}
.Upload-sec-wrapper .file-name {
  background: #f4f4f5;
  display: inline-flex;
  padding: 10px;
  margin-top: 8px;
  border-radius: 4px;
  margin-right: 15px;
  justify-content: space-between;
  width: auto;
  max-width: 100%;
}
.Upload-sec-wrapper .file-name span.file-name-txt {
  display: inline-block;
  width: calc(100% - 30px);
  line-height: 20px;
}
.Upload-sec-wrapper .file-name .upload-size-info {
  display: inline-flex;
  color: #71777f;
  float: right;
  white-space: nowrap;
  position: relative;
  top: 3px;
  margin-left: 8px;
}
.Upload-sec-wrapper .file-name .upload-size-info > span {
  cursor: pointer;
}
.Upload-sec-wrapper .file-list-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 24px;
}
.Upload-sec-wrapper .file-list-wrapper .file-name {
  background: #f4f4f5;
  display: inline-flex;
  padding: 10px;
  margin-top: 8px;
  border-radius: 4px;
  margin-right: 15px;
  justify-content: space-between;
  width: auto;
  max-width: 100%;
}
.Upload-sec-wrapper .file-list-wrapper .file-name span.file-name-txt {
  display: inline-block;
  width: calc(100% - 30px);
  line-height: 20px;
}
.Upload-sec-wrapper .file-list-wrapper .file-name .upload-size-info {
  display: inline-flex;
  color: #71777f;
  float: right;
  white-space: nowrap;
  position: relative;
  top: 3px;
  margin-left: 8px;
}
.Upload-sec-wrapper .file-list-wrapper .file-name .upload-size-info > span {
  cursor: pointer;
}
.Upload-sec-wrapper .file-list-wrapper .invalid-file-name {
  background: #f4f4f5;
  display: inline-flex;
  padding: 10px;
  margin-top: 8px;
  border-radius: 4px;
  margin-right: 15px;
  justify-content: space-between;
  width: auto;
  max-width: 100%;
  color: #841b24;
}
.Upload-sec-wrapper .file-list-wrapper .invalid-file-name span.file-name-txt {
  display: inline-block;
  width: calc(100% - 30px);
  line-height: 20px;
}
.Upload-sec-wrapper .file-list-wrapper .invalid-file-name .upload-size-info {
  display: inline-flex;
  float: right;
  white-space: nowrap;
  position: relative;
  top: 3px;
  margin-left: 8px;
}
.Upload-sec-wrapper .file-list-wrapper .invalid-file-name .upload-size-info > span {
  cursor: pointer;
}
.Upload-sec-wrapper .invalid-feedback {
  display: block;
}
.Upload-sec-wrapper .custom-calender {
  position: relative;
}
.Upload-sec-wrapper .custom-calender input {
  padding-left: 30px;
}
.Upload-sec-wrapper .custom-calender i.calender-ic {
  position: absolute;
  bottom: 7px;
  left: 10px;
}
.Upload-sec-wrapper .grey-error {
  color: #7b8289;
  font-size: 12px;
  position: relative;
  bottom: -6px;
  left: auto;
}
.Upload-sec-wrapper .agendas-datepicker .datepickerDV {
  top: -3px;
}
.Upload-sec-wrapper .agendas-datepicker .datepickerDV .react-datepicker__input-container input {
  border: 1px solid #ced4da;
}
.Upload-sec-wrapper .agendas-datepicker .date-input.error.is-invalid {
  border-color: #dc3545;
}
.Upload-sec-wrapper .agendas-datepicker #helpText {
  position: relative;
  top: -2px;
}

.mark,
mark {
  padding: 0.2em;
}

.flex-box.toast-flex-box {
  display: inline-flex;
}

.document-info-sec {
  position: absolute;
  right: 0;
  top: -18px;
  width: 340px;
  background: #fff;
  height: 100%;
  box-sizing: border-box;
  padding: 20px 0px 20px 20px;
  z-index: 9;
}
.document-info-sec .custom-scrollbar {
  max-height: calc(100vh - 300px);
}
.document-info-sec .astm-card {
  border-radius: 0;
  cursor: pointer;
}
.document-info-sec .astm-card h2.card-header {
  line-height: 0px;
  padding: 10px;
}
.document-info-sec .astm-card h2.card-header span {
  color: #232f3a;
  font-family: Proxima Nova Bold, sans-serif;
  line-height: 16px;
  font-size: 16px;
}
.document-info-sec .astm-card h2.card-header span i {
  transition: all 0.4s ease;
}
.document-info-sec .astm-card h2.card-header span i.astm-toggle-arrow {
  transform: rotateZ(-90deg);
}
.document-info-sec .astm-card h2.card-header span:hover {
  text-decoration: none;
}
.document-info-sec .astm-card .right-action-btn {
  display: flex;
  align-items: center;
  position: absolute;
  right: 10px;
  top: 10px;
}
.document-info-sec .astm-card .right-action-btn > svg {
  margin-right: 13px;
  cursor: pointer;
  opacity: 0.5;
  width: 16px;
  display: none;
}
.document-info-sec .astm-card .right-action-btn > svg:hover {
  opacity: 1;
}
.document-info-sec .astm-card .right-action-btn i {
  color: #8d9398;
  cursor: pointer;
  margin: 0;
  padding: 0;
  position: relative;
  top: -2px;
}
.document-info-sec .astm-card .right-action-btn i::before {
  font-size: 20px;
}
.document-info-sec .astm-card .right-action-btn i:hover {
  color: #232f3a;
}
.document-info-sec .astm-card .card-body .section-info-wrapper {
  cursor: default;
}
.document-info-sec .astm-card .card-body .section-info-wrapper li {
  display: flex;
  margin-bottom: 16px;
}
.document-info-sec .astm-card .card-body .section-info-wrapper li label.name {
  width: 40%;
  font-size: 14px;
  padding-right: 15px;
}
.document-info-sec .astm-card .card-body .section-info-wrapper li .doc-info {
  word-break: break-word !important;
  width: 60%;
  font-size: 14px;
  white-space: normal;
}
.document-info-sec .astm-card .card-body .section-info-wrapper li .doc-info .dropdown-menu {
  min-width: 100px;
}
.document-info-sec .astm-card .card-body .section-info-wrapper li .doc-info a.dropdown-item {
  margin-bottom: 0;
}
.document-info-sec .astm-card .card-body .section-info-wrapper li .doc-info button.btn.astm-btn.astm-link.dropdown-toggle {
  color: #232f3a;
  display: flex !important;
  align-items: center;
  position: relative;
}
.document-info-sec .astm-card .card-body .section-info-wrapper li .doc-info button.btn.astm-btn.astm-link.dropdown-toggle::after {
  position: absolute;
  right: -15px;
  padding: 1px;
}
.document-info-sec .astm-card .card-body .section-info-wrapper li .doc-info .active-status {
  background: #386c38;
  border: 0;
  color: #fff;
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 12px;
  font-family: Proxima Nova Bold, sans-serif;
}
.document-info-sec .astm-card .card-body .section-info-wrapper li .doc-info .inactive-status {
  background: #941f29;
  border: 0;
  color: #fff;
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 12px;
  font-family: Proxima Nova Bold, sans-serif;
}
.document-info-sec .astm-card .card-body .section-info-wrapper li .doc-info .default-status {
  background: #fff;
  border: 0;
  color: #232f3a;
  border-radius: 4px;
  padding: 2px 8px;
  font-family: Proxima Nova, sans-serif;
  font-size: 14px;
  text-align: left;
  max-width: 120px;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 0;
  line-height: 16px;
}
.document-info-sec .astm-card .card-body .section-info-wrapper li .doc-info .file-size-txt {
  font-size: 12px;
  color: #71777f;
  font-family: "Proxima Nova", sans-serif;
  position: relative;
  top: -10px;
  left: 28px;
}
.document-info-sec .astm-card .card-body .section-info-wrapper li .doc-info .collabration-file-size-txt {
  font-size: 12px;
  color: #71777f;
  font-family: "Proxima Nova", sans-serif;
  position: relative;
  top: -10px;
  left: 0px;
}
.document-info-sec .astm-card .card-body .section-info-wrapper li .doc-info span {
  font-size: 14px;
}
.document-info-sec .astm-card .card-body .section-info-wrapper li .doc-info span.badge {
  margin: 0 4px 4px 0;
  white-space: normal;
}
.document-info-sec .astm-card .card-body .section-info-wrapper li .doc-info .astm-badge.custom-badge {
  font-family: "Proxima Nova", sans-serif;
  font-weight: 500;
  white-space: normal;
}
.document-info-sec .astm-card .card-body .section-info-wrapper li .doc-info span.blue-color {
  color: #005da4;
  line-height: 16px;
}
.document-info-sec .astm-card .card-body .section-info-wrapper li .doc-info button.btn.show-more-txt {
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 0;
  font-size: 14px;
  color: #005da4;
}
.document-info-sec .astm-card .card-body .section-info-wrapper li .doc-info a {
  display: flex;
  font-size: 14px;
  margin-bottom: 16px;
}
.document-info-sec .astm-card .card-body .section-info-wrapper li .doc-info a svg {
  height: 18px;
  flex: 0 0 16px;
  margin-right: 10px;
}
.document-info-sec .astm-card .card-body .section-info-wrapper li .doc-info a:hover {
  text-decoration: none;
}
.document-info-sec .astm-card .card-body .section-info-wrapper li .doc-info a:last-child {
  margin-bottom: 0px;
}
.document-info-sec .astm-card .card-body .section-info-wrapper li .doc-info.flyover-item > span {
  background: #232f3a;
  display: inline-block;
  color: #fff;
  border-radius: 0.25rem;
  padding: 0.25em 0.4em;
  font-family: Proxima Nova Bold, sans-serif;
  font-size: 12px !important;
  letter-spacing: 1px;
}
.document-info-sec .astm-card .card-body .section-info-wrapper li:last-child {
  margin-bottom: 0;
}
.document-info-sec .astm-card .card-body.doc-log-wrapper {
  padding: 0;
}
.document-info-sec .astm-card .card-body.doc-log-wrapper ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.document-info-sec .astm-card .card-body.doc-log-wrapper ul li {
  padding: 1.25rem;
  border-bottom: 1px solid #ddd;
}
.document-info-sec .astm-card .card-body.doc-log-wrapper ul li p.year-info {
  font-weight: bold;
}
.document-info-sec .astm-card .card-body.doc-log-wrapper ul li p {
  line-height: 17px;
}
.document-info-sec .astm-card .card-body.doc-log-wrapper ul li:last-child {
  border: 0;
}

.tooltip.bs-tooltip-end .tooltip-inner::before {
  left: -13px;
  top: 50%;
  transform: translateY(-50%);
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-right: 8px solid #303030;
}

.tooltip.bs-tooltip-end {
  left: 5px !important;
}

#Committee::-webkit-scrollbar-track,
#LetterBallotNumber::-webkit-scrollbar-track {
  border-radius: 4px;
  background-color: #fff;
}

#Committee::-webkit-scrollbar,
#LetterBallotNumber::-webkit-scrollbar {
  width: 5px;
  background-color: #cccccc;
}

#Committee::-webkit-scrollbar-thumb,
#LetterBallotNumber::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: #cfcfcf;
}

.list-group .card.astm-card {
  border: 0 !important;
}

.custom-flex .form-check-label {
  position: relative;
  top: 2px;
}

.doc-info.remove-active .dropdown {
  cursor: default;
}
.doc-info.remove-active button.btn {
  cursor: default;
}
.doc-info.remove-active .dropdown-toggle::after {
  display: none;
}
.doc-info.remove-active .astm-link:focus,
.doc-info.remove-active .btn:focus,
.doc-info.remove-active button:focus {
  outline: none !important;
  box-shadow: none !important;
}

.permission-wrapper {
  text-align: center;
  margin-top: 64px;
}
.permission-wrapper p {
  color: #71777f;
  font-size: 16px;
}
.permission-wrapper h4 {
  font-size: 24px;
  color: #71777f;
}

.astm-alert.top-toster {
  position: fixed !important;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 9999;
}
.astm-alert.top-toster > button {
  border: 0;
}
.astm-alert.top-toster .top-toser-ic {
  position: absolute;
  left: 18px;
  top: 10px;
  display: inline-block;
  width: 20px;
}

.astm-alert.bg-success--light.top-toster::before {
  opacity: 0;
}

.btn-close {
  display: none;
}

.flex-box.toast-flex-box.alert-dismissible-toaster {
  display: flex;
  padding-left: 25px;
  justify-content: space-between;
  flex-wrap: wrap;
}
.flex-box.toast-flex-box.alert-dismissible-toaster .btn-close {
  display: none;
}
.flex-box.toast-flex-box.alert-dismissible-toaster .astm-alert-text {
  padding-left: 0;
}
.flex-box.toast-flex-box.alert-dismissible-toaster span {
  line-height: 18px;
}

.alert-success .toster-inline-view {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0 0 0 25px;
}
.alert-success .toster-inline-view li {
  margin-right: 10px;
  font-size: 14px;
  list-style: none;
  position: relative;
  line-height: 16px;
  padding-left: 10px;
}
.alert-success .toster-inline-view li:first-child {
  padding-left: 0;
}
.alert-success .toster-inline-view li::before {
  content: "";
  position: absolute;
  left: 0px;
  top: 6px;
  width: 5px;
  height: 5px;
  border-radius: 100%;
  background: #386c38;
}
.alert-success .toster-inline-view li:first-child::before {
  display: none;
}

.toster-inline-view {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0 0 0 25px;
}
.toster-inline-view li {
  margin-right: 10px;
  font-size: 14px;
  list-style: none;
  position: relative;
  line-height: 16px;
  padding-left: 10px;
}
.toster-inline-view li:first-child {
  padding-left: 0;
}
.toster-inline-view li::before {
  content: "";
  position: absolute;
  left: 0px;
  top: 6px;
  width: 5px;
  height: 5px;
  border-radius: 100%;
  background: #841b24;
}
.toster-inline-view li:first-child::before {
  display: none;
}

.astm-alert .close.custom-close-btn {
  position: absolute;
  top: 20px;
  right: 35px;
}
.astm-alert .close.custom-close-btn > span {
  font-size: 24px;
}

.btn-close {
  display: none;
}

.flex-box.toast-flex-box.alert-dismissible-toaster {
  display: flex;
  padding-left: 25px;
}
.flex-box.toast-flex-box.alert-dismissible-toaster .btn-close {
  display: none;
}
.flex-box.toast-flex-box.alert-dismissible-toaster .astm-alert-text {
  padding-left: 0;
}
.flex-box.toast-flex-box.alert-dismissible-toaster span {
  line-height: 18px;
}

.astm-alert .close.custom-close-btn {
  position: absolute;
  top: 20px;
  right: 35px;
}
.astm-alert .close.custom-close-btn > span {
  font-size: 24px;
}

.input-prefix-text {
  position: absolute;
  top: 25px;
  background: rgba(35, 47, 58, 0.06);
  padding: 10px 11px;
  left: 16px;
  width: 50px;
  border-right: 1px solid rgb(221, 221, 221);
}

#WorkItemNumber {
  padding-left: 58px;
}

.ballot-detail-wrapper .top-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  position: absolute;
  width: calc(100% - 41px);
  background: #fff;
  padding-bottom: 10px;
  top: 20px;
  left: 25px;
  z-index: 9;
}
.ballot-detail-wrapper .top-left-sec {
  display: flex;
  align-items: center;
}
.ballot-detail-wrapper .top-left-sec .zip-txt {
  font-size: 14px;
  color: #71777f;
  margin: 0;
  padding-left: 8px;
}
.ballot-detail-wrapper .top-left-sec .back-btn {
  margin-right: 16px;
}
.ballot-detail-wrapper .top-left-sec .ballot-numb {
  font-size: 24px;
  color: #232f3a;
  line-height: 32px;
  font-family: Proxima Nova, sans-serif;
}
.ballot-detail-wrapper .top-left-sec .ballot-numb > span {
  font-size: 24px;
  color: #232f3a;
  margin-right: 10px;
  display: inline-block;
  line-height: 32px;
  font-family: Proxima Nova, sans-serif;
}
.ballot-detail-wrapper .ballot-table-wrapper table {
  margin-bottom: 0;
}
.ballot-detail-wrapper .ballot-table-wrapper table .slide-icons {
  position: absolute;
  top: -4px;
  left: -30px;
}
.ballot-detail-wrapper .ballot-table-wrapper {
  margin-top: 70px;
}
.ballot-detail-wrapper .ballot-table-wrapper .action-icons a.showReplaceIocnZip {
  opacity: 0.2;
  background: transparent;
}
.ballot-detail-wrapper .ballot-table-wrapper .action-icons a.showReplaceIocnZip:hover {
  opacity: 0.2;
  background: transparent;
}
.ballot-detail-wrapper .ballot-table-wrapper .action-icons a.active {
  opacity: 1;
  background: rgba(35, 47, 58, 0.06);
  color: #101010;
  text-decoration: none;
}
.ballot-detail-wrapper .ballot-table-wrapper .remove-first-col tr th:nth-child(1),
.ballot-detail-wrapper .ballot-table-wrapper .remove-first-col tr td:nth-child(1) {
  display: none;
}
.ballot-detail-wrapper .ballot-table-wrapper .remove-first-col tr th:nth-child(2),
.ballot-detail-wrapper .ballot-table-wrapper .remove-first-col tr th:nth-child(3),
.ballot-detail-wrapper .ballot-table-wrapper .remove-first-col tr td:nth-child(2),
.ballot-detail-wrapper .ballot-table-wrapper .remove-first-col tr td:nth-child(3) {
  width: 45%;
}
.ballot-detail-wrapper .ballot-table-wrapper .remove-first-col .showReplaceIocn {
  display: flex;
  transform: rotateZ(-90deg);
  opacity: 0.4;
}
.ballot-detail-wrapper .ballot-table-wrapper table thead tr th:nth-child(1) {
  width: 5%;
}
.ballot-detail-wrapper .ballot-table-wrapper table thead tr th:nth-child(2) {
  width: 51%;
}
.ballot-detail-wrapper .ballot-table-wrapper table thead tr th:nth-child(3) {
  width: 32%;
}
.ballot-detail-wrapper .ballot-table-wrapper table thead tr th:nth-child(4) {
  width: 22%;
}
.ballot-detail-wrapper .ballot-table-wrapper table tbody tr td:nth-child(1) {
  width: 5%;
  text-align: center;
}
.ballot-detail-wrapper .ballot-table-wrapper table tbody tr td:nth-child(1) svg {
  position: relative;
  cursor: pointer;
}
.ballot-detail-wrapper .ballot-table-wrapper table tbody tr td:nth-child(1) svg.remove-hand-ic {
  cursor: default;
}
.ballot-detail-wrapper .ballot-table-wrapper table tbody tr td:nth-child(2) {
  width: 51%;
}
.ballot-detail-wrapper .ballot-table-wrapper table tbody tr td:nth-child(3) {
  width: 32%;
}
.ballot-detail-wrapper .ballot-table-wrapper table tbody tr td:nth-child(4) {
  width: 22%;
}
.ballot-detail-wrapper .ballot-table-wrapper .td-col-one {
  display: flex;
  justify-content: space-between;
  width: 370px;
}
.ballot-detail-wrapper .ballot-table-wrapper .td-col-one .doc-name {
  width: calc(100% - 60px);
  word-wrap: break-word;
  padding-right: 20px;
  line-height: 20px;
  font-family: "Proxima Nova", sans-serif;
}
.ballot-detail-wrapper .ballot-table-wrapper .td-col-one .pdf-word-ic {
  position: relative;
  width: 60px;
  display: inline-block;
  height: 30px;
  top: -5px;
}
.ballot-detail-wrapper .ballot-table-wrapper .td-col-one .pdf-word-ic svg {
  width: 14px;
}
.ballot-detail-wrapper .ballot-table-wrapper .td-col-one .flyover-Wrapper {
  display: flex;
  width: 100px;
}
.ballot-detail-wrapper .ballot-table-wrapper .td-col-one .flyover-Wrapper .flyover-flag {
  background: #232f3a;
  width: 18px;
  height: 19px;
  color: white;
  border-radius: 3px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Proxima Nova Bold, sans-serif;
  margin-bottom: 4px;
  position: relative;
  top: 1px;
  margin-left: 8px;
}
.ballot-detail-wrapper .ballot-table-wrapper .td-col-one .flyover-Wrapper .flyover-flag:last-child {
  margin-bottom: 0;
}
.ballot-detail-wrapper .ballot-table-wrapper .td-col-one .flyover-Wrapper .flyover-grey-light-flag {
  background: #dddddd;
  width: 18px;
  height: 19px;
  color: #232f3a;
  border-radius: 3px;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Proxima Nova Bold, sans-serif;
  margin-bottom: 4px;
  margin-left: 8px;
  position: relative;
  top: 1px;
}
.ballot-detail-wrapper .ballot-table-wrapper .td-col-one .flyover-Wrapper .flyover-grey-light-flag:last-child {
  margin-bottom: 0;
}
.ballot-detail-wrapper .ballot-table-wrapper .action-icons {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  text-align: center;
  position: relative;
  top: -4px;
}
.ballot-detail-wrapper .ballot-table-wrapper .action-icons .replac-doc-ic {
  display: none;
  transform: rotateZ(-90deg);
}
.ballot-detail-wrapper .ballot-table-wrapper .action-icons .showReplaceIocn {
  display: flex;
  transform: rotateZ(-90deg);
}
.ballot-detail-wrapper .ballot-table-wrapper .action-icons a {
  opacity: 0.5;
  color: #232f3a;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
}
.ballot-detail-wrapper .ballot-table-wrapper .action-icons a:hover {
  opacity: 1;
  background: rgba(35, 47, 58, 0.06);
  color: #101010;
  text-decoration: none;
}

.ballot-detail-wrapper.failed-panel-wrapper .ballot-table-wrapper {
  margin-top: 0;
  height: 100vh;
}

.showReplaceIocnZip {
  display: flex;
  transform: rotateZ(-90deg);
  opacity: 0.4;
}
.showReplaceIocnZip:hover {
  opacity: 0.4;
  background: transparent;
}

.badge.zip-txt {
  font-size: 14px;
  color: #71777f;
  margin: 0;
  padding-left: 8px;
  font-weight: normal;
}

.badge.zip-progess-txt {
  font-size: 14px;
  color: #7e6417;
  margin: 0;
  padding-left: 8px;
  font-weight: normal;
  padding-bottom: 0;
  padding-top: 0;
  font-family: "Proxima Nova", sans-serif;
}

.badge.zip-txt.zip-progres-wrapper {
  font-weight: 300;
  margin-left: 16px;
}

.no-result-txt {
  text-align: center;
  padding: 60px;
  color: #71777f;
  font-family: Proxima Nova, sans-serif;
}

.dismiss-toaster-wrapper {
  position: absolute;
  top: 0px;
  width: 100%;
}
.dismiss-toaster-wrapper > .astm-alert.top-toster {
  position: relative !important;
  margin-bottom: 0;
}

.modal-dialog.modal-dialog-centered.apply-litigation-wrapper {
  max-width: 600px;
  top: -14px;
}

.apply-litigation-wrapper {
  font-family: "Proxima Nova", sans-serif;
}
.apply-litigation-wrapper .rbt-token {
  background-color: #f4f4f5;
  color: #232f3a;
}
.apply-litigation-wrapper .rbt-input-multi.form-control.rbt-input input.rbt-input-main {
  padding: 0.25rem 0.5rem !important;
}
.apply-litigation-wrapper .custom-input-box {
  position: relative;
}
.apply-litigation-wrapper .custom-input-box input {
  position: absolute;
  top: -3px;
}
.apply-litigation-wrapper .custom-input-box i {
  position: absolute;
  left: 255px;
  top: 0;
}
.apply-litigation-wrapper .custom-input-box .astm-custom-radio label::before {
  content: "";
  background: #fff;
  width: 15px;
  height: 15px;
  display: inline-block;
  border-radius: 100%;
  border: #adb5bd solid 1px;
  position: absolute;
  top: 0px;
  left: -1px;
}
.apply-litigation-wrapper .custom-input-box .astm-custom-radio.active.form-check label::after {
  content: "";
  display: inline-block;
  border: 1px solid #005da4;
  background-color: #005da4;
  position: absolute;
  z-index: 1;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  left: -1px;
  top: 0px;
}
.apply-litigation-wrapper .custom-input-box .astm-custom-radio.active.form-check label::before {
  background: #fff;
  width: 5px;
  height: 5px;
  content: "";
  display: inline-block;
  z-index: 2;
  border-radius: 100%;
  top: 5px;
  left: 4px;
  border: 0;
}

.litigation-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  width: calc(100% - 41px);
  background: #fff;
  top: 20px;
  left: 25px;
  padding: 0 0 15px 0;
  z-index: 1;
}
.litigation-header .search-ballot-box {
  position: relative;
  position: relative;
  width: 400px;
  height: 38px;
}
.litigation-header .search-ballot-box > input {
  width: 100%;
  min-width: 400px;
  max-width: 100%;
  padding-right: 30px;
}
.litigation-header .search-ballot-box .search-ic {
  position: absolute;
  right: 15px;
  top: 10px;
}

.litigation-table-panel .table-filter-listing {
  margin-top: 50px;
}
.litigation-table-panel .table-filter-listing .table th:nth-child(5),
.litigation-table-panel .table-filter-listing .table td:nth-child(5) {
  width: 20%;
  font-family: "Proxima Nova", sans-serif;
}
.litigation-table-panel .table-filter-listing .table th:nth-child(2),
.litigation-table-panel .table-filter-listing .table td:nth-child(2) {
  width: 28%;
  font-family: "Proxima Nova", sans-serif;
}
.litigation-table-panel .table-filter-listing .table th:nth-child(2) i {
  display: none;
}
.litigation-table-panel .table-filter-listing .table th:nth-child(1),
.litigation-table-panel .table-filter-listing .table th:nth-child(3),
.litigation-table-panel .table-filter-listing .table th:nth-child(4) {
  display: table-cell;
  width: 14%;
  font-family: "Proxima Nova", sans-serif;
}
.litigation-table-panel .table-filter-listing .table td:nth-child(1),
.litigation-table-panel .table-filter-listing .table td:nth-child(3),
.litigation-table-panel .table-filter-listing .table td:nth-child(4),
.litigation-table-panel .table-filter-listing .table td:nth-child(5) {
  display: table-cell;
  width: 15%;
  font-family: "Proxima Nova", sans-serif;
}

.action-icons {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  text-align: center;
  position: relative;
  top: -4px;
}
.action-icons a {
  opacity: 0.5;
  color: #232f3a;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
}
.action-icons a i {
  cursor: pointer;
  height: 30px;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.action-icons a:hover {
  opacity: 1;
  background: rgba(35, 47, 58, 0.06);
  color: #101010;
  text-decoration: none;
}

.d-flex {
  display: flex;
}

.datepickerDV .react-datepicker__input-container input.error.is-invalid {
  border: solid 1px #dc3545;
}

.display-none {
  display: none;
}

.custom-toggle-Infomation .link-btn {
  margin-left: 4px;
  color: #005da4;
  cursor: pointer;
  position: relative;
}
.custom-toggle-Infomation .number-col {
  position: relative;
  display: inline-block;
}
.custom-toggle-Infomation .show-info-col {
  position: absolute;
  background: #fff;
  width: 260px;
  padding: 10px;
  border: 1px solid #dddddd;
  top: 25px;
  z-index: 99;
  color: #232f3a;
  line-height: 20px;
  left: -125px;
}
.custom-toggle-Infomation .show-info-col::before {
  content: "";
  position: absolute;
  top: -6px;
  z-index: 11;
  display: block;
  border-top: 1px solid #ddd;
  border-left: 1px solid #ddd;
  width: 10px;
  transform: rotate(45deg);
  height: 10px;
  background: #fff;
  left: 50%;
}

.astm-table.table-striped tbody tr:last-child .custom-toggle-Infomation .show-info-col,
.astm-table.table-striped tbody tr:nth-last-child(2) .custom-toggle-Infomation .show-info-col,
.astm-table.table-striped tbody tr:nth-last-child(3) .custom-toggle-Infomation .show-info-col,
.astm-table.table-striped tbody tr:nth-last-child(4) .custom-toggle-Infomation .show-info-col {
  top: auto;
  bottom: 28px;
}
.astm-table.table-striped tbody tr:last-child .custom-toggle-Infomation .show-info-col::before,
.astm-table.table-striped tbody tr:nth-last-child(2) .custom-toggle-Infomation .show-info-col::before,
.astm-table.table-striped tbody tr:nth-last-child(3) .custom-toggle-Infomation .show-info-col::before,
.astm-table.table-striped tbody tr:nth-last-child(4) .custom-toggle-Infomation .show-info-col::before {
  transform: rotate(226deg);
  top: auto;
  bottom: -6px;
}
.astm-table.table-striped tbody tr:last-child .custom-toggle-Infomation .show-info-col.custom-increase-width::before,
.astm-table.table-striped tbody tr:nth-last-child(2) .custom-toggle-Infomation .show-info-col.custom-increase-width::before,
.astm-table.table-striped tbody tr:nth-last-child(3) .custom-toggle-Infomation .show-info-col.custom-increase-width::before,
.astm-table.table-striped tbody tr:nth-last-child(4) .custom-toggle-Infomation .show-info-col.custom-increase-width::before {
  left: 23%;
}

.astm-table.table-striped tbody tr:first-child .custom-toggle-Infomation .show-info-col,
.astm-table.table-striped tbody tr:nth-child(2) .custom-toggle-Infomation .show-info-col {
  bottom: auto;
  top: 28px;
}
.astm-table.table-striped tbody tr:first-child .custom-toggle-Infomation .show-info-col::before,
.astm-table.table-striped tbody tr:nth-child(2) .custom-toggle-Infomation .show-info-col::before {
  transform: rotate(46deg);
  bottom: auto;
  top: -6px;
}
.astm-table.table-striped tbody tr:first-child .custom-toggle-Infomation .show-info-col.custom-increase-width::before,
.astm-table.table-striped tbody tr:nth-child(2) .custom-toggle-Infomation .show-info-col.custom-increase-width::before {
  left: 23%;
}

.custom-toggle-Infomation .show-info-col.custom-increase-width::before {
  left: 23%;
}

.show-info-col.custom-increase-width {
  width: 600px;
}

.react-datepicker__input-container input:disabled,
.react-datepicker__input-container input[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}

.disable-close-ic {
  opacity: 0.3;
}

table.vote-attachments-table-wrapper .showReplaceIocn.disable-ic {
  opacity: 0.3;
  pointer-events: none;
}

.bulk-delete-head {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.bulk-delete-head .document-count {
  font-size: 16px;
  color: #232f3a;
  font-family: Proxima Nova, sans-serif;
}
.bulk-delete-head .document-count > span {
  display: inline-block;
  margin-right: 9px;
}
.bulk-delete-head .document-count .close-btn {
  color: rgba(35, 47, 58, 0.51);
  margin-left: 16px;
  cursor: pointer;
  position: relative;
  top: 1px;
}
.bulk-delete-head .document-count .close-btn:hover {
  color: #232f3a;
}
.bulk-delete-head .btn-outline-danger {
  color: #941f29;
  border-color: #941f29;
}
.bulk-delete-head .btn-outline-danger:hover {
  background: #f4f4f5;
  color: #941f29;
  border-color: #941f29;
}

.remove-bulk-delete-sec {
  display: none;
}

.committee-COS-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 18px;
  font-size: 14px;
  font-family: Proxima Nova Bold, sans-serif;
  color: white;
  margin-left: 10px;
  background-color: #232f3a;
  border-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./src/layout/_layoutScreen.scss"],"names":[],"mappings":"AAAA;;;;;;;;EAQE,wBAAA;EACA,2BAAA;AACF;;AAEE;EACE,cAAA;AACJ;;AAEA;;EAEE,8BAAA;AACF;;AAII;EACE,YAAA;AADN;;AAKA;EACE,6BAAA;AAFF;;AAMI;EACE,kBAAA;EACA,sCAAA;AAHN;AAKM;EACE,oBAAA;AAHR;AAMM;EACE,qBAAA;EACA,sBAAA;AAJR;;AAUA;EACE,iCAAA;AAPF;;AAUA;;EAEE,sBAAA;AAPF;;AAWA;EACE,UAAA;EACA,eAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;EACA,uCAAA;AARF;;AAeA;EACE,kBAAA;EACA,iBAAA;EACA,2BAAA;AAZF;AAcE;EACE,YAAA;EACA,UAAA;EACA,0CAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,+BAAA;EACA,gBAAA;AAZJ;AAcI;EACE,gBAAA;EACA,SAAA;EACA,mBAAA;AAZN;AAeQ;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;AAbV;AAeU;EACE,qBAAA;EACA,kCAAA;AAbZ;AAgBU;EACE,WAAA;AAdZ;AAgBY;EACE,kBAAA;EACA,UAAA;AAdd;AAkBU;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;AAhBZ;AAmBU;EACE,mBAAA;EACA,0BAAA;AAjBZ;AAoBU;EACE,aAAA;AAlBZ;AAsBQ;EACE,qBAAA;EACA,kCAAA;EACA,cAAA;AApBV;AAyBY;EACE,kBAAA;EACA,8BAAA;AAvBd;AAyBc;EACE,qBAAA;EACA,8BAAA;AAvBhB;AAgCM;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,0BAAA;EACA,oBAAA;AA9BR;AAgCQ;EACE,eAAA;AA9BV;AAiCQ;EACE,qBAAA;AA/BV;AAkCQ;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;AAhCV;AAoCM;EACE,qBAAA;EACA,kCAAA;EACA,cAAA;AAlCR;AAqCI;EACE,aAAA;AAnCN;AAsCI;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,yDAAA;AApCN;AAsCM;EACE,4BAAA;EACA,kBAAA;EACA,SAAA;AApCR;AAsCQ;EACE,eAAA;AApCV;AAyCI;EACE,wBAAA;AAvCN;AA0CI;EACE,kBAAA;EACA,cAAA;AAxCN;AA4CE;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;AA1CJ;AA4CI;EACE,2BAAA;EACA,YAAA;AA1CN;AA4CI;EACE,mBAAA;EACA,yBAAA;EACA,SAAA;EACA,aAAA;AA1CN;AA2CM;EACE,aAAA;AAzCR;AA0CQ;EACE,iBAAA;EACA,qBAAA;AAxCV;AA0CQ;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,qCAAA;AAxCV;AA2CM;EACE,SAAA;EACA,mBAAA;AAzCR;AA0CQ;EACE,UAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,qCAAA;AAxCV;AA2CM;EACE,gBAAA;AAzCR;AA4CI;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;AA1CN;AA4CI;EACE,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,SAAA;AA1CN;;AA+CA;EACE,gBAAA;AA5CF;;AA+CA;EACE,WAAA;AA5CF;AA8CE;EACE,kBAAA;EACA,wBAAA;AA5CJ;AA8CI;EACE,eAAA;AA5CN;AA8CM;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;AA5CR;AA8CQ;EACE,SAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;AA5CV;AA+CQ;EACE,cAAA;AA7CV;AA+CQ;EACE,aAAA;AA7CV;AAoDI;EACE,aAAA;AAlDN;AAqDI;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AAnDN;AAqDM;EACE,WAAA;AAnDR;AAsDM;EACE,cAAA;AApDR;AAsDQ;EACE,aAAA;AApDV;AAyDQ;EACE,kBAAA;EACA,SAAA;AAvDV;AA6DE;EACE,kBAAA;EACA,aAAA;AA3DJ;AA8DE;EACE,iBAAA;AA5DJ;AA+DM;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AA7DR;AA+DQ;EACE,SAAA;EACA,UAAA;AA7DV;AAoEI;EACE,cAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;AAlEN;;AAuEA;EACE,kBAAA;EACA,wBAAA;EACA,iBAAA;AApEF;AAsEE;EACE,0BAAA;AApEJ;AAsEI;EACE,kBAAA;AApEN;AA2EQ;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,WAAA;AAzEV;AA6EQ;EACE,qBAAA;EACA,WAAA;AA3EV;AAgFE;EACE,wBAAA;EACA,OAAA;AA9EJ;AAiFI;EACE,uBAAA;EACA,OAAA;EACA,yBAAA;AA/EN;AAiFI;EACE,kBAAA;AA/EN;AAmFI;EACE,uBAAA;EACA,OAAA;EACA,yBAAA;AAjFN;AAoFE;EACE,kBAAA;AAlFJ;;AAuFE;EACE,kBAAA;AApFJ;AAsFI;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AApFN;AAsFI;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AApFN;AAuFI;EACE,UAAA;EACA,oBAAA;AArFN;AAuFI;EACE,UAAA;AArFN;AAyFI;EACE,iBAAA;AAvFN;AA2FI;EACE,kBAAA;AAzFN;AA2FI;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AAzFN;AA2FI;EACE,oBAAA;EACA,SAAA;AAzFN;AA2FI;EACE,oBAAA;EACA,wBAAA;AAzFN;AA+FQ;EACE,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;AA7FV;;AAoGA;EACE,oCAAA;AAjGF;AA0GU;;;;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,WAAA;AArGZ;AA6GI;EACE,sBAAA;AA3GN;AA8GM;EACE,WAAA;AA5GR;AAgHM;EACE,WAAA;AA9GR;AAkHM;EACE,WAAA;AAhHR;AAoHM;EACE,WAAA;AAlHR;AAsHM;EACE,WAAA;AApHR;AAwHM;EACE,WAAA;AAtHR;AA0HI;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;AAxHN;AA0HI;EACE,YAAA;AAxHN;AA6HI;EACE,YAAA;AA3HN;AA6HI;EACE,YAAA;AA3HN;AAiIM;EACE,YAAA;AA/HR;AAkIQ;EACE,oBAAA;EACA,WAAA;AAhIV;AA8IU;;;;;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,WAAA;EACA,sBAAA;AAxIZ;AAiJY;EACE,WAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;AA/Id;AAyJM;EACE,YAAA;AAvJR;AA4JE;EACE,YAAA;AA1JJ;AA8JI;EACE,mBAAA;AA5JN;AA8JI;EACE,YAAA;AA5JN;AAiKI;EACE,aAAA;AA/JN;AAkKE;EACE,mBAAA;AAhKJ;AAkKE;EACE,mBAAA;AAhKJ;AAmKE;EACE,iBAAA;AAjKJ;AAmKE;EACE,iBAAA;AAjKJ;AAmKI;EACE,gBAAA;AAjKN;AAmKM;EACE,YAAA;AAjKR;AAuKI;EACE,YAAA;AArKN;;AA0KA;EACE,aAAA;AAvKF;;AA0KA;EACE,0BAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;AAvKF;AAyKE;EACE,cAAA;EACA,cAAA;AAvKJ;;AA2KA;EACE,gBAAA;AAxKF;;AA2KA;EACE,mBAAA;AAxKF;;AA2KA;EACE,gBAAA;EACA,mBAAA;AAxKF;;AA2KA;EACE,wBAAA;AAxKF;;AA2KA;EACE,kBAAA;EACA,YAAA;AAxKF;;AA2KA;EACE,2BAAA;EACA,kBAAA;AAxKF;AA0KE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,6BAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;AAxKJ;;AA6KE;EACE,2BAAA;EACA,kBAAA;AA1KJ;;AA8KA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,YAAA;AA3KF;;AA8KA;EACE,gBAAA;EACA,kBAAA;EACA,+BAAA;AA3KF;;AA8KA;;EAGE,kBAAA;EACA,yBAAA;AA5KF;;AA+KA;;EAEE,UAAA;EACA,yBAAA;AA5KF;;AA+KA;;EAEE,kBAAA;EAEA,yBAAA;AA7KF;;AAiLE;EACE,oCAAA;AA9KJ;;AAkLA;;;EAGE,yBAAA;EACA,oCAAA;EACA,gCAAA;AA/KF;;AAkLA;EACE,kBAAA;EACA,mBAAA;AA/KF;AAiLE;EACE,iBAAA;EACA,eAAA;AA/KJ;AAiLE;EACE,kBAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;AA/KJ;AAmLI;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;AAjLN;AAoLI;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,UAAA;AAlLN;AAoLM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAlLR;AAuLE;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AArLJ;AAwLE;EACE,mBAAA;EACA,qBAAA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;AAtLJ;AAwLI;EACE,iBAAA;EACA,kBAAA;EACA,SAAA;AAtLN;AA0LE;EACE,mBAAA;EACA,oBAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,8BAAA;EACA,WAAA;EACA,eAAA;AAxLJ;AA0LI;EACE,qBAAA;EACA,wBAAA;EACA,iBAAA;AAxLN;AA2LI;EACE,oBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,gBAAA;AAzLN;AA2LM;EACE,eAAA;AAzLR;AA8LE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AA5LJ;AA8LI;EACE,mBAAA;EACA,oBAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,8BAAA;EACA,WAAA;EACA,eAAA;AA5LN;AA8LM;EACE,qBAAA;EACA,wBAAA;EACA,iBAAA;AA5LR;AA+LM;EACE,oBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,gBAAA;AA7LR;AA+LQ;EACE,eAAA;AA7LV;AAkMI;EACE,mBAAA;EACA,oBAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,8BAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AAhMN;AAkMM;EACE,qBAAA;EACA,wBAAA;EACA,iBAAA;AAhMR;AAmMM;EACE,oBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,gBAAA;AAjMR;AAmMQ;EACE,eAAA;AAjMV;AAuME;EACE,cAAA;AArMJ;AAwME;EACE,kBAAA;AAtMJ;AAwMI;EACE,kBAAA;AAtMN;AAyMI;EACE,kBAAA;EACA,WAAA;EACA,UAAA;AAvMN;AA2ME;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;AAzMJ;AA6MI;EACE,SAAA;AA3MN;AA8MI;EACE,yBAAA;AA5MN;AA+MI;EACE,qBAAA;AA7MN;AAiNE;EACE,kBAAA;EACA,SAAA;AA/MJ;;AAmNA;;EAEE,cAAA;AAhNF;;AAmNA;EACE,oBAAA;AAhNF;;AAoNA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,2BAAA;EACA,UAAA;AAjNF;AAmNE;EACE,+BAAA;AAjNJ;AAoNE;EACE,gBAAA;EACA,eAAA;AAlNJ;AAoNI;EACE,gBAAA;EACA,aAAA;AAlNN;AAoNM;EACE,cAAA;EACA,0CAAA;EACA,iBAAA;EACA,eAAA;AAlNR;AAoNQ;EACE,yBAAA;AAlNV;AAqNQ;EACE,0BAAA;AAnNV;AAsNQ;EACE,qBAAA;AApNV;AAyNI;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AAvNN;AAyNM;EACE,kBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;AAvNR;AAyNQ;EACE,UAAA;AAvNV;AA2NM;EACE,cAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;AAzNR;AA2NQ;EACE,eAAA;AAzNV;AA4NQ;EACE,cAAA;AA1NV;AAgOM;EACE,eAAA;AA9NR;AAgOQ;EACE,aAAA;EACA,mBAAA;AA9NV;AAgOU;EACE,UAAA;EACA,eAAA;EACA,mBAAA;AA9NZ;AAiOU;EACE,iCAAA;EACA,UAAA;EACA,eAAA;EACA,mBAAA;AA/NZ;AAiOY;EACE,gBAAA;AA/Nd;AAkOY;EACE,gBAAA;AAhOd;AAmOY;EACE,cAAA;EACA,wBAAA;EACA,mBAAA;EACA,kBAAA;AAjOd;AAmOc;EACE,kBAAA;EACA,YAAA;EACA,YAAA;AAjOhB;AAqOY;EACE,mBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,0CAAA;AAnOd;AAqOY;EACE,mBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,0CAAA;AAnOd;AAqOY;EACE,gBAAA;EACA,SAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;AAnOd;AAsOY;EACE,eAAA;EACA,cAAA;EACA,uCAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;AApOd;AAsOY;EACE,eAAA;EACA,cAAA;EACA,uCAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;AApOd;AAsOY;EACE,eAAA;AApOd;AAuOY;EACE,mBAAA;EACA,mBAAA;AArOd;AAwOY;EACE,uCAAA;EACA,gBAAA;EACA,mBAAA;AAtOd;AAyOY;EACE,cAAA;EACA,iBAAA;AAvOd;AAyOY;EACE,SAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAvOd;AA0OY;EACE,aAAA;EACA,eAAA;EACA,mBAAA;AAxOd;AA0Oc;EACE,YAAA;EACA,cAAA;EACA,kBAAA;AAxOhB;AA2Oc;EACE,qBAAA;AAzOhB;AA4Oc;EACE,kBAAA;AA1OhB;AAgPY;EACE,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,sBAAA;EACA,qBAAA;EACA,0CAAA;EACA,0BAAA;EACA,mBAAA;AA9Od;AAkPU;EACE,gBAAA;AAhPZ;AAsPI;EACE,UAAA;AApPN;AAsPM;EACE,gBAAA;EACA,SAAA;EACA,UAAA;AApPR;AAsPQ;EACE,gBAAA;EACA,6BAAA;AApPV;AAsPU;EAEE,iBAAA;AArPZ;AAwPU;EACE,iBAAA;AAtPZ;AAyPU;EACE,SAAA;AAvPZ;;AAgQA;EACE,WAAA;EACA,QAAA;EACA,2BAAA;EACA,iCAAA;EACA,oCAAA;EACA,+BAAA;AA7PF;;AA+PA;EACE,oBAAA;AA5PF;;AA+PA;;EAGE,kBAAA;EACA,sBAAA;AA7PF;;AAgQA;;EAEE,UAAA;EACA,yBAAA;AA7PF;;AAgQA;;EAEE,kBAAA;EAEA,yBAAA;AA9PF;;AAkQE;EACE,oBAAA;AA/PJ;;AAmQA;EACE,kBAAA;EACA,QAAA;AAhQF;;AAoQE;EACE,eAAA;AAjQJ;AAmQE;EACE,eAAA;AAjQJ;AAmQE;EACE,aAAA;AAjQJ;AAmQE;;;EAGE,wBAAA;EACA,2BAAA;AAjQJ;;AAuQA;EACE,kBAAA;EACA,gBAAA;AApQF;AAsQE;EACE,cAAA;EACA,eAAA;AApQJ;AAuQE;EACE,eAAA;EACA,cAAA;AArQJ;;AA0QA;EACE,0BAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;AAvQF;AAwQE;EACE,SAAA;AAtQJ;AAwQE;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,qBAAA;EACA,WAAA;AAtQJ;;AA0QA;EACE,UAAA;AAvQF;;AA2QA;EACE,aAAA;AAxQF;;AA2QA;EACE,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,eAAA;AAxQF;AAyQE;EACE,aAAA;AAvQJ;AAyQE;EACE,eAAA;AAvQJ;AA0QE;EACE,iBAAA;AAxQJ;;AA6QE;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;AA1QJ;AA2QI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AAzQN;AA0QM;EACE,eAAA;AAxQR;AA0QM;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;AAxQR;AA2QM;EACE,aAAA;AAzQR;;AA+QA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;AA5QF;AA6QE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AA3QJ;AA4QI;EACE,eAAA;AA1QN;AA4QI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;AA1QN;AA6QI;EACE,aAAA;AA3QN;;AAgRA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AA7QF;AA8QE;EACE,eAAA;AA5QJ;;AAqRA;EACE,aAAA;AAlRF;;AAqRA;EACE,aAAA;EACA,kBAAA;AAlRF;AAoRE;EACE,aAAA;AAlRJ;AAqRE;EACE,eAAA;AAnRJ;AAqRE;EACE,iBAAA;AAnRJ;;AAuRA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AApRF;AAsRE;EACE,eAAA;AApRJ;;AA0RA;EACE,kBAAA;EACA,SAAA;EACA,kCAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,0CAAA;AAvRF;;AA0RA;EACE,kBAAA;AAvRF;;AA2RE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,oBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;AAxRJ;AA2RE;EACE,aAAA;EACA,mBAAA;AAzRJ;AA2RI;EACE,eAAA;EACA,cAAA;EACA,SAAA;EACA,iBAAA;AAzRN;AA4RI;EACE,kBAAA;AA1RN;AA4RI;EACE,eAAA;EACA,cAAA;EACA,iBAAA;EACA,qCAAA;AA1RN;AA4RM;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,qCAAA;AA1RR;AAgSI;EACE,gBAAA;AA9RN;AA+RM;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AA7RR;AAuRE;EASE,gBAAA;AA7RJ;AAgSM;EACE,YAAA;EACA,uBAAA;AA9RR;AAgSQ;EACE,YAAA;EACA,uBAAA;AA9RV;AAiSM;EACE,UAAA;EACA,kCAAA;EACA,cAAA;EACA,qBAAA;AA/RR;AAqSQ;;EAEE,aAAA;AAnSV;AAqSQ;;;;EAIE,UAAA;AAnSV;AAsSM;EACE,aAAA;EACA,0BAAA;EACA,YAAA;AApSR;AA2SU;EACE,SAAA;AAzSZ;AA2SU;EACE,UAAA;AAzSZ;AA2SU;EACE,UAAA;AAzSZ;AA2SU;EACE,UAAA;AAzSZ;AA+SU;EACE,SAAA;EACA,kBAAA;AA7SZ;AA8SY;EACE,kBAAA;EACA,eAAA;AA5Sd;AA8SY;EACE,eAAA;AA5Sd;AA+SU;EACE,UAAA;AA7SZ;AA+SU;EACE,UAAA;AA7SZ;AA+SU;EACE,UAAA;AA7SZ;AAmTI;EACE,aAAA;EACA,8BAAA;EACA,YAAA;AAjTN;AAmTM;EACE,wBAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,uCAAA;AAjTR;AAoTM;EACE,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,YAAA;EACA,SAAA;AAlTR;AAoTQ;EACE,WAAA;AAlTV;AAqTM;EACE,aAAA;EACA,YAAA;AAnTR;AAqTQ;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,gBAAA;AAnTV;AAqTU;EACE,gBAAA;AAnTZ;AAsTQ;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;AApTV;AAsTU;EACE,gBAAA;AApTZ;AAyTI;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AAvTN;AAyTM;EACE,aAAA;EACA,0BAAA;AAvTR;AAyTM;EACE,aAAA;EACA,0BAAA;AAvTR;AA0TM;EACE,YAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAxTR;AA0TQ;EACE,UAAA;EACA,kCAAA;EACA,cAAA;EACA,qBAAA;AAxTV;;AAgUE;EACE,aAAA;EACA,aAAA;AA7TJ;;AAgUA;EACE,aAAA;EACA,0BAAA;EACA,YAAA;AA7TF;AA8TE;EACE,YAAA;EACA,uBAAA;AA5TJ;;AAgUA;EACE,eAAA;EACA,cAAA;EACA,SAAA;EACA,iBAAA;EACA,mBAAA;AA7TF;;AA+TA;EACE,eAAA;EACA,cAAA;EACA,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,uCAAA;AA5TF;;AA8TA;EACE,gBAAA;EACA,iBAAA;AA3TF;;AA6TA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,qCAAA;AA1TF;;AA6TA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;AA1TF;AA4TE;EACE,6BAAA;EACA,gBAAA;AA1TJ;;AA+TA;EACE,gBAAA;EACA,UAAA;AA5TF;;AA8TA;EACE,uCAAA;AA3TF;AA4TE;EACE,yBAAA;EACA,cAAA;AA1TJ;AA6TI;EACE,kCAAA;AA3TN;AA+TE;EACE,kBAAA;AA7TJ;AA8TI;EACE,kBAAA;EACA,SAAA;AA5TN;AA8TI;EACE,kBAAA;EACA,WAAA;EACA,MAAA;AA5TN;AA+TM;EACE,WAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AA7TR;AAiUM;EACE,WAAA;EACA,qBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;EACA,QAAA;AA/TR;AAiUM;EACE,gBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,qBAAA;EACA,UAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EACA,SAAA;AA/TR;;AAqUA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,UAAA;AAlUF;AAoUE;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;AAlUJ;AAmUI;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAjUN;AAmUI;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AAjUN;;AAsUE;EACE,gBAAA;AAnUJ;AAqUM;;EAEE,UAAA;EACA,uCAAA;AAnUR;AAqUM;;EAEE,UAAA;EACA,uCAAA;AAnUR;AAsUQ;EACE,aAAA;AApUV;AAuUM;;;EAGE,mBAAA;EACA,UAAA;EACA,uCAAA;AArUR;AAuUM;;;;EAIE,mBAAA;EACA,UAAA;EACA,uCAAA;AArUR;;AA0UA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AAvUF;AAwUE;EACE,YAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAtUJ;AAwUI;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAtUN;AAyUI;EACE,UAAA;EACA,kCAAA;EACA,cAAA;EACA,qBAAA;AAvUN;;AA2UA;EACE,aAAA;AAxUF;;AA0UA;EACE,yBAAA;AAvUF;;AAyUA;EACE,aAAA;AAtUF;;AAyUE;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAtUJ;AAwUE;EACE,kBAAA;EACA,qBAAA;AAtUJ;AAwUE;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;AAtUJ;AAwUI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,0BAAA;EACA,2BAAA;EACA,WAAA;EACA,wBAAA;EACA,YAAA;EACA,gBAAA;EACA,SAAA;AAtUN;;AAgVI;;;;EACE,SAAA;EACA,YAAA;AA1UN;AA2UM;;;;EACE,yBAAA;EACA,SAAA;EACA,YAAA;AAtUR;AA0UM;;;;EACE,SAAA;AArUR;;AA8UI;;EACE,YAAA;EACA,SAAA;AA1UN;AA2UM;;EACE,wBAAA;EACA,YAAA;EACA,SAAA;AAxUR;AA4UM;;EACE,SAAA;AAzUR;;AA+UA;EACE,SAAA;AA5UF;;AA+UA;EACE,YAAA;AA5UF;;AAiVA;;EAEE,yBAAA;EACA,UAAA;AA9UF;;AAgVA;EACE,YAAA;AA7UF;;AAiVE;EACE,YAAA;EACA,oBAAA;AA9UJ;;AAiVA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AA9UF;AA+UE;EACE,eAAA;EACA,cAAA;EACA,qCAAA;AA7UJ;AA8UI;EACE,qBAAA;EACA,iBAAA;AA5UN;AA8UI;EACE,6BAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;AA5UN;AA6UM;EACE,cAAA;AA3UR;AA+UE;EACE,cAAA;EACA,qBAAA;AA7UJ;AA+UE;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AA7UJ;;AAgVA;EACE,aAAA;AA7UF;;AA+UA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,0CAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;AA5UF","sourcesContent":["textarea:focus,\ninput:focus,\na:focus,\na:hover:focus,\nbutton:focus,\n.btn.focus,\n.btn:focus,\n.astm-btn:focus {\n  outline: none !important;\n  box-shadow: none !important;\n}\n.modal-body {\n  .invalid-feedback {\n    display: block;\n  }\n}\ndiv#deleteModal,\n#itemNumberModal {\n  background: rgb(0 0 0 / 40%);\n}\n\n.logoWrap {\n  a {\n    img {\n      height: 57px;\n    }\n  }\n}\n.mr16 {\n  margin-right: 16px !important;\n}\nheader {\n  .topMenuBar {\n    .menuWrapper {\n      flex-grow: inherit;\n      justify-content: flex-start !important;\n\n      a {\n        padding: 20px 0 18px;\n      }\n\n      .dropdown-item {\n        text-decoration: none;\n        padding: 0.5rem 1.5rem;\n      }\n    }\n  }\n}\n\n.dropdown-item {\n  padding: 0.5rem 1.5rem !important;\n}\n\n.dropdown-item:focus,\n.dropdown-item:hover {\n  padding: 0.5rem 1.5rem;\n}\n\n// breadcrumb-wrapper css ====================================================================\n.breadcrumb-wrapper {\n  z-index: 9;\n  position: fixed;\n  top: 144px;\n  background: #fff;\n  width: 100%;\n  font-family: \"Proxima Nova\", sans-serif;\n}\n\n// breadcrumb-wrapper css End ================================================================\n\n// Left Menu css =================================================================================\n\n.middle-container {\n  position: relative;\n  margin-top: 125px;\n  height: calc(100vh - 270px);\n\n  .leftMenuSection {\n    width: 255px;\n    padding: 0;\n    border-right: 1px solid rgb(221, 221, 221);\n    position: absolute;\n    left: 0;\n    top: 0px;\n    min-height: calc(100vh - 270px);\n    transition: 0.5s;\n\n    ul {\n      list-style: none;\n      margin: 0;\n      padding: 16px 0 0 0;\n\n      li {\n        a {\n          display: flex;\n          align-items: center;\n          color: rgb(0, 93, 164);\n          padding: 16px 0;\n          font-size: 14px;\n          white-space: nowrap;\n          padding-left: 15px;\n          border-radius: 4px 0 0 4px;\n          position: relative;\n\n          &:hover {\n            text-decoration: none;\n            background: rgb(35 47 58 / 6%);\n          }\n\n          span.menu-ic {\n            width: 28px;\n\n            .collabration-ic {\n              position: relative;\n              left: -2px;\n            }\n          }\n\n          svg {\n            margin-right: 14px;\n            margin-bottom: 0;\n            color: #232f3a;\n            position: relative;\n            top: -2px;\n          }\n\n          span.menu-name {\n            white-space: nowrap;\n            font-size: 14px !important;\n          }\n\n          .custom-tool-tip {\n            display: none;\n          }\n        }\n\n        a.active {\n          text-decoration: none;\n          background: rgb(35 47 58 / 6%);\n          color: #232f3a;\n        }\n\n        .inner-sub-menu {\n          li {\n            a {\n              padding: 14px 14px;\n              border-radius: 4px 0px 0px 4px;\n\n              &:hover {\n                text-decoration: none;\n                background: rgb(244, 244, 245);\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .document-menu-sec {\n      & > a {\n        display: flex;\n        align-items: center;\n        color: rgb(0, 93, 164);\n        padding: 16px 0;\n        font-size: 14px;\n        white-space: nowrap;\n        padding-left: 15px;\n        border-radius: 4px 0 0 4px;\n        pointer-events: none;\n\n        .menu-name {\n          font-size: 14px;\n        }\n\n        &:hover {\n          text-decoration: none;\n        }\n\n        svg {\n          margin-right: 14px;\n          margin-bottom: 0;\n          color: #232f3a;\n          position: relative;\n          top: -2px;\n        }\n      }\n\n      a.active {\n        text-decoration: none;\n        background: rgb(35 47 58 / 6%);\n        color: #232f3a;\n      }\n    }\n    .custom-tool-tip {\n      display: none;\n    }\n\n    button.btn.toggle-Btn {\n      position: absolute;\n      top: 25px;\n      right: -15px;\n      background: #fff;\n      border-radius: 100%;\n      border: 1px solid #f1f1f1;\n      width: 30px;\n      height: 30px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      z-index: 91;\n      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1) !important;\n\n      i {\n        color: rgb(35 47 58 / 50%);\n        position: relative;\n        top: -1px;\n\n        &::before {\n          font-size: 13px;\n        }\n      }\n    }\n\n    .toggle-Btn.removeSidebarToggleIcon {\n      display: none !important;\n    }\n\n    ul.inner-sub-menu {\n      padding-left: 30px;\n      padding-top: 0;\n    }\n  }\n\n  .rightSectionWrap {\n    position: relative;\n    width: calc(100% - 255px);\n    margin-left: 255px;\n    padding: 20px 0 0 0;\n    transition: 0.5s;\n    height: 100%;\n\n    .custom-scrollbar {\n      padding: 0px 10px 10px 25px;\n      height: 100%;\n    }\n    .failure-info-section {\n      background: #fef9ea;\n      border: 1px solid #fef4d5;\n      margin: 0;\n      padding: 20px;\n      .heading-panel {\n        display: flex;\n        svg {\n          margin-right: 8px;\n          display: inline-block;\n        }\n        p {\n          color: #7e6417;\n          font-size: 14px;\n          line-height: 16px;\n          font-family: Proxima Nova, sans-serif;\n        }\n      }\n      ul {\n        margin: 0;\n        padding: 0 0 0 20px;\n        li {\n          padding: 0;\n          margin: 0;\n          color: #7e6417;\n          font-size: 14px;\n          line-height: 16px;\n          font-family: Proxima Nova, sans-serif;\n        }\n      }\n      .btm-action-btns {\n        margin-top: 16px;\n      }\n    }\n    .top-header.custom-top-position {\n      position: static;\n      width: 100%;\n      margin-top: 20px;\n      padding: 0;\n    }\n    .top-header.custom-top-position.ballotFixedHeader {\n      position: absolute;\n      width: calc(100% - 40px);\n      background: #fff;\n      top: 20px;\n      padding: 0 0 10px 0;\n      margin: 0;\n    }\n  }\n}\n\n.custom-scrollbar.remove-scroll {\n  overflow: hidden;\n}\n\n.middle-container.remove-sidebar .leftMenuSection {\n  width: 60px;\n\n  ul {\n    margin-right: 30px;\n    width: calc(100% - 20px);\n\n    li {\n      margin-top: 5px;\n\n      a {\n        width: 36px;\n        height: 42px;\n        display: flex;\n        justify-content: center;\n        padding: 0;\n        border-radius: 4px;\n        position: relative;\n\n        svg {\n          margin: 0;\n          padding: 10px;\n          width: 36px;\n          height: 36px;\n        }\n\n        .custom-tool-tip {\n          display: block;\n        }\n        .menu-ic {\n          display: none;\n        }\n      }\n    }\n  }\n\n  .document-menu-sec {\n    .menu-ic.document-ic {\n      display: none;\n    }\n\n    a {\n      width: 36px;\n      border-radius: 4px;\n      height: 36px;\n      padding-left: 8px;\n\n      span.menu-ic.document-ic {\n        width: 20px;\n      }\n\n      .custom-tool-tip {\n        display: block;\n\n        svg {\n          padding: 10px;\n        }\n      }\n\n      .custom-tool-tip.doc-big-ic {\n        svg {\n          padding: 0 6px 0 0;\n          left: 0px;\n        }\n      }\n    }\n  }\n\n  span.menu-name {\n    visibility: hidden;\n    display: none;\n  }\n\n  ul.inner-sub-menu {\n    padding-left: 0px;\n\n    li {\n      a {\n        padding: 14px 0;\n        width: 36px;\n        height: 36px;\n        display: flex;\n        justify-content: center;\n        border-radius: 4px;\n        margin-bottom: 5px;\n\n        svg {\n          margin: 0;\n          padding: 0;\n        }\n      }\n    }\n  }\n\n  button.btn.toggle-Btn {\n    i {\n      rotate: 180deg;\n      position: relative;\n      left: 2px;\n      top: 2px;\n    }\n  }\n}\n\n.middle-container.remove-sidebar .rightSectionWrap {\n  position: relative;\n  width: calc(100% - 70px);\n  margin-left: 70px;\n\n  .custom-scrollbar {\n    padding: 0px 10px 25px 0px;\n\n    .listing-filter-sec {\n      padding-left: 20px;\n    }\n  }\n\n  .ballot-queue-table-wrapper {\n    tr {\n      th:nth-child(5) {\n        .table-heading-text {\n          text-overflow: unset;\n          white-space: nowrap;\n          overflow: unset;\n          display: inline-block;\n          width: auto;\n        }\n      }\n      th:nth-child(6) {\n        .table-heading-text {\n          display: inline-block;\n          width: auto;\n        }\n      }\n    }\n  }\n  .litigation-header {\n    width: calc(100% - 16px);\n    left: 0;\n  }\n  .main-ballot-wrapper {\n    .top-search-Ballot-wrapper {\n      width: calc(100% - 6px);\n      left: 0;\n      padding: 0 10px 10px 15px;\n    }\n    .ballot-list-wrap {\n      padding-left: 15px;\n    }\n  }\n  .litigation-wrapper {\n    .litigation-header {\n      width: calc(100% - 6px);\n      left: 0;\n      padding: 0 10px 10px 15px;\n    }\n  }\n  .table-filter-listing {\n    padding-left: 15px;\n  }\n}\n\n.middle-container.remove-sidebar {\n  .ballot-detail-wrapper {\n    padding-left: 20px;\n\n    .btm-placement {\n      position: absolute;\n      left: 100px;\n      top: 38px;\n    }\n    .zip-txt.btm-zip-placement {\n      position: absolute;\n      left: 220px;\n      top: 40px;\n    }\n\n    .top-header {\n      left: 20px;\n      padding-bottom: 28px;\n    }\n    .top-header.custom-top-position {\n      top: 245px;\n    }\n  }\n  .ballot-detail-wrapper.sequence-Committee-Wrapper {\n    .top-header {\n      padding-bottom: 0;\n    }\n  }\n  .ballot-detail-wrapper.failed-panel-wrapper {\n    .top-left-sec {\n      position: relative;\n    }\n    .btm-placement {\n      position: absolute;\n      left: 100px;\n      top: 34px;\n    }\n    .top-header {\n      padding-bottom: 10px;\n      top: 20px;\n    }\n    .top-header.custom-top-position.ballotFixedHeader {\n      padding-bottom: 25px;\n      width: calc(100% - 35px);\n    }\n  }\n  .rightSectionWrap.adjust-rightSectionWrap {\n    .ballot-queue-table-wrapper {\n      th:nth-child(5) {\n        .table-heading-text {\n          width: 42px;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n          overflow: hidden;\n          display: inline-block;\n        }\n      }\n    }\n  }\n}\n\n.rightSectionWrap.adjust-rightSectionWrap {\n  width: calc(100% - 410px) !important;\n\n  table {\n    thead {\n      tr {\n        th:nth-child(3),\n        th:nth-child(4),\n        th:nth-child(5),\n        th:nth-child(6) {\n          .table-heading-text {\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            overflow: hidden;\n            display: inline-block;\n            width: 60px;\n          }\n        }\n      }\n    }\n  }\n\n  .ballot-queue-table-wrapper {\n    td {\n      word-break: break-word;\n    }\n    th:nth-child(2) {\n      .table-heading-text {\n        width: auto;\n      }\n    }\n    th:nth-child(3) {\n      .table-heading-text {\n        width: 40px;\n      }\n    }\n    th:nth-child(4) {\n      .table-heading-text {\n        width: 40px;\n      }\n    }\n    th:nth-child(5) {\n      .table-heading-text {\n        width: 42px;\n      }\n    }\n    th:nth-child(6) {\n      .table-heading-text {\n        width: 50px;\n      }\n    }\n    th:nth-child(7) {\n      .table-heading-text {\n        width: 50px;\n      }\n    }\n\n    .table-heading-text {\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      overflow: hidden;\n      display: inline-block;\n    }\n    .td-col-one {\n      width: 140px;\n    }\n  }\n\n  table.collaboration-wrapper {\n    th:nth-child(2) {\n      width: 230px;\n    }\n    .td-col-one {\n      width: 200px;\n    }\n  }\n\n  .table-filter-listing {\n    table.collaboration-wrapper {\n      td:nth-child(2) {\n        width: 230px;\n      }\n      th:nth-child(5) {\n        .table-heading-text {\n          text-overflow: unset;\n          width: auto;\n        }\n      }\n    }\n  }\n\n  table.ballot-items-table-wrapper {\n    thead {\n      tr {\n        th:nth-child(3),\n        th:nth-child(4),\n        th:nth-child(5),\n        th:nth-child(6),\n        th:nth-child(7) {\n          .table-heading-text {\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            overflow: hidden;\n            display: inline-block;\n            width: 40px;\n            vertical-align: bottom;\n          }\n        }\n      }\n    }\n    tbody {\n      tr {\n        td {\n          .indicator-container {\n            button {\n              width: 90px;\n              display: inline-block;\n              word-break: break-word;\n              white-space: normal;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .listing-filter-sec {\n    .custom-search-wrapper {\n      .seach-box-sec {\n        width: 338px;\n      }\n    }\n  }\n\n  .td-col-one {\n    width: 180px;\n  }\n\n  .closing-reports-wrapper {\n    th.pointer {\n      padding-right: 20px;\n    }\n    .td-col-one {\n      width: 130px;\n    }\n  }\n\n  .flex-box {\n    label {\n      display: none;\n    }\n  }\n  .astm-table thead tr th.pointer {\n    padding-right: 30px;\n  }\n  .astm-table.closing-reports-wrapper thead tr th.pointer {\n    padding-right: 20px;\n  }\n\n  .custom-scrollbar {\n    padding-left: 5px;\n  }\n  .listing-filter-sec {\n    padding-left: 5px;\n\n    .vote-search-box {\n      max-width: 520px;\n\n      .input-Box.ballot-seach {\n        width: 260px;\n      }\n    }\n  }\n\n  .closing-reports-wrapper {\n    .td-col-one {\n      width: 240px;\n    }\n  }\n}\n\nul.inner-sub-menu.remove-inner-sidebar {\n  display: none;\n}\n\n.fa-asterisk.disabled-star {\n  margin-right: 0 !important;\n  width: 10px;\n  position: relative;\n  top: -5px;\n\n  &::before {\n    font-size: 6px;\n    color: #71777f;\n  }\n}\n\n.mt24 {\n  margin-top: 24px;\n}\n\n.mb24 {\n  margin-bottom: 24px;\n}\n\n.mtb24 {\n  margin-top: 24px;\n  margin-bottom: 24px;\n}\n\n.h-145 {\n  height: 145px !important;\n}\n\n.small-txt-info {\n  position: absolute;\n  bottom: -3px;\n}\n\n.tooltip .tooltip-inner {\n  max-width: 200px !important;\n  position: relative;\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    width: 0;\n    height: 0;\n    border-left: 7px solid transparent;\n    border-right: 7px solid transparent;\n    border-top: 8px solid #303030;\n    bottom: -8px;\n    left: 50%;\n    transform: translateX(-50%);\n  }\n}\n\n.tooltip.custom-tooltip-panel {\n  .tooltip-inner {\n    max-width: 280px !important;\n    position: relative;\n  }\n}\n\n.CustomLoader {\n  position: absolute;\n  left: 60%;\n  top: 65%;\n  transform: translate(-50%, -50%);\n  z-index: 999;\n}\n\n.custom-scrollbar {\n  overflow-y: auto;\n  overflow-x: hidden;\n  max-height: calc(100vh - 280px);\n}\n\n#scroll-bar::-webkit-scrollbar-track,\n.ballot-list-wrap::-webkit-scrollbar-track {\n  // -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);\n  border-radius: 4px;\n  background-color: #e7e7e7;\n}\n\n#scroll-bar::-webkit-scrollbar,\n.ballot-list-wrap::-webkit-scrollbar {\n  width: 6px;\n  background-color: #cccccc;\n}\n\n#scroll-bar::-webkit-scrollbar-thumb,\n.ballot-list-wrap::-webkit-scrollbar-thumb {\n  border-radius: 4px;\n  // -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);\n  background-color: #cfcfcf;\n}\n\n.profileOptionMenu.dropdown {\n  .dropdown-menu {\n    inset: 0px -1px auto auto !important;\n  }\n}\n\n.profileOptionMenu.dropdown .btn-success:not(:disabled):not(.disabled).active,\n.profileOptionMenu.dropdown .btn-success:not(:disabled):not(.disabled):active,\n.profileOptionMenu.dropdown .show > .btn-success.dropdown-toggle {\n  color: #232f3a !important;\n  background-color: #fdc92f !important;\n  border-color: #fdc92f !important;\n}\n\n.Upload-sec-wrapper {\n  padding-left: 10px;\n  padding-right: 10px;\n\n  .character-limt-txt {\n    text-align: right;\n    margin-top: 8px;\n  }\n  .form-group.status-dropdown select {\n    position: relative;\n    top: -1px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .darg-drop-box {\n    input {\n      opacity: 0;\n      width: 100%;\n      position: absolute;\n      left: 50%;\n      top: 50%;\n      transform: translate(-50%, -50%);\n      z-index: 1;\n      height: 100%;\n      cursor: pointer;\n    }\n\n    .upload-txt {\n      position: absolute;\n      left: 50%;\n      top: 50%;\n      transform: translate(-50%, -50%);\n      z-index: 0;\n\n      span {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        margin-top: 10px;\n      }\n    }\n  }\n\n  .custom-flex {\n    height: 100%;\n    display: flex;\n    align-items: center;\n    margin-top: -1px;\n  }\n\n  .errorMessage {\n    background: #f4e9ea;\n    display: inline-block;\n    padding: 0.75rem 1.25rem;\n    border-radius: 4px;\n    margin-right: 15px;\n    border: 1px solid #ebd6d8;\n    color: #841b24;\n\n    .invalid-icon {\n      margin-right: 8px;\n      position: relative;\n      top: -1px;\n    }\n  }\n\n  .file-name {\n    background: #f4f4f5;\n    display: inline-flex;\n    padding: 10px;\n    margin-top: 8px;\n    border-radius: 4px;\n    margin-right: 15px;\n    justify-content: space-between;\n    width: auto;\n    max-width: 100%;\n\n    span.file-name-txt {\n      display: inline-block;\n      width: calc(100% - 30px);\n      line-height: 20px;\n    }\n\n    .upload-size-info {\n      display: inline-flex;\n      color: #71777f;\n      float: right;\n      white-space: nowrap;\n      position: relative;\n      top: 3px;\n      margin-left: 8px;\n\n      & > span {\n        cursor: pointer;\n      }\n    }\n  }\n\n  .file-list-wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    margin-bottom: 24px;\n\n    .file-name {\n      background: #f4f4f5;\n      display: inline-flex;\n      padding: 10px;\n      margin-top: 8px;\n      border-radius: 4px;\n      margin-right: 15px;\n      justify-content: space-between;\n      width: auto;\n      max-width: 100%;\n\n      span.file-name-txt {\n        display: inline-block;\n        width: calc(100% - 30px);\n        line-height: 20px;\n      }\n\n      .upload-size-info {\n        display: inline-flex;\n        color: #71777f;\n        float: right;\n        white-space: nowrap;\n        position: relative;\n        top: 3px;\n        margin-left: 8px;\n\n        & > span {\n          cursor: pointer;\n        }\n      }\n    }\n\n    .invalid-file-name {\n      background: #f4f4f5;\n      display: inline-flex;\n      padding: 10px;\n      margin-top: 8px;\n      border-radius: 4px;\n      margin-right: 15px;\n      justify-content: space-between;\n      width: auto;\n      max-width: 100%;\n      color: #841b24;\n\n      span.file-name-txt {\n        display: inline-block;\n        width: calc(100% - 30px);\n        line-height: 20px;\n      }\n\n      .upload-size-info {\n        display: inline-flex;\n        float: right;\n        white-space: nowrap;\n        position: relative;\n        top: 3px;\n        margin-left: 8px;\n\n        & > span {\n          cursor: pointer;\n        }\n      }\n    }\n  }\n\n  .invalid-feedback {\n    display: block;\n  }\n\n  .custom-calender {\n    position: relative;\n\n    input {\n      padding-left: 30px;\n    }\n\n    i.calender-ic {\n      position: absolute;\n      bottom: 7px;\n      left: 10px;\n    }\n  }\n\n  .grey-error {\n    color: #7b8289;\n    font-size: 12px;\n    position: relative;\n    bottom: -6px;\n    left: auto;\n  }\n\n  .agendas-datepicker {\n    .datepickerDV {\n      top: -3px;\n    }\n\n    .datepickerDV .react-datepicker__input-container input {\n      border: 1px solid #ced4da;\n    }\n\n    .date-input.error.is-invalid {\n      border-color: #dc3545;\n    }\n  }\n\n  .agendas-datepicker #helpText {\n    position: relative;\n    top: -2px;\n  }\n}\n\n.mark,\nmark {\n  padding: 0.2em;\n}\n\n.flex-box.toast-flex-box {\n  display: inline-flex;\n}\n\n// document info (Right panel) all documents list screen\n.document-info-sec {\n  position: absolute;\n  right: 0;\n  top: -18px;\n  width: 340px;\n  background: #fff;\n  height: 100%;\n  box-sizing: border-box;\n  padding: 20px 0px 20px 20px;\n  z-index: 9;\n\n  .custom-scrollbar {\n    max-height: calc(100vh - 300px);\n  }\n\n  .astm-card {\n    border-radius: 0;\n    cursor: pointer;\n\n    h2.card-header {\n      line-height: 0px;\n      padding: 10px;\n\n      span {\n        color: #232f3a;\n        font-family: Proxima Nova Bold, sans-serif;\n        line-height: 16px;\n        font-size: 16px;\n\n        i {\n          transition: all 0.4s ease;\n        }\n\n        i.astm-toggle-arrow {\n          transform: rotateZ(-90deg);\n        }\n\n        &:hover {\n          text-decoration: none;\n        }\n      }\n    }\n\n    .right-action-btn {\n      display: flex;\n      align-items: center;\n      position: absolute;\n      right: 10px;\n      top: 10px;\n\n      & > svg {\n        margin-right: 13px;\n        cursor: pointer;\n        opacity: 0.5;\n        width: 16px;\n        display: none;\n\n        &:hover {\n          opacity: 1;\n        }\n      }\n\n      i {\n        color: #8d9398;\n        cursor: pointer;\n        margin: 0;\n        padding: 0;\n        position: relative;\n        top: -2px;\n\n        &::before {\n          font-size: 20px;\n        }\n\n        &:hover {\n          color: #232f3a;\n        }\n      }\n    }\n\n    .card-body {\n      .section-info-wrapper {\n        cursor: default;\n\n        li {\n          display: flex;\n          margin-bottom: 16px;\n\n          label.name {\n            width: 40%;\n            font-size: 14px;\n            padding-right: 15px;\n          }\n\n          .doc-info {\n            word-break: break-word !important;\n            width: 60%;\n            font-size: 14px;\n            white-space: normal;\n\n            .dropdown-menu {\n              min-width: 100px;\n            }\n\n            a.dropdown-item {\n              margin-bottom: 0;\n            }\n\n            button.btn.astm-btn.astm-link.dropdown-toggle {\n              color: #232f3a;\n              display: flex !important;\n              align-items: center;\n              position: relative;\n\n              &::after {\n                position: absolute;\n                right: -15px;\n                padding: 1px;\n              }\n            }\n\n            .active-status {\n              background: #386c38;\n              border: 0;\n              color: #fff;\n              border-radius: 4px;\n              padding: 2px 8px;\n              font-size: 12px;\n              font-family: Proxima Nova Bold, sans-serif;\n            }\n            .inactive-status {\n              background: #941f29;\n              border: 0;\n              color: #fff;\n              border-radius: 4px;\n              padding: 2px 8px;\n              font-size: 12px;\n              font-family: Proxima Nova Bold, sans-serif;\n            }\n            .default-status {\n              background: #fff;\n              border: 0;\n              color: #232f3a;\n              border-radius: 4px;\n              padding: 2px 8px;\n              font-family: Proxima Nova, sans-serif;\n              font-size: 14px;\n              text-align: left;\n              max-width: 120px;\n              margin: 0;\n              padding: 0;\n              border: 0;\n              border-radius: 0;\n              line-height: 16px;\n            }\n\n            .file-size-txt {\n              font-size: 12px;\n              color: #71777f;\n              font-family: \"Proxima Nova\", sans-serif;\n              position: relative;\n              top: -10px;\n              left: 28px;\n            }\n            .collabration-file-size-txt {\n              font-size: 12px;\n              color: #71777f;\n              font-family: \"Proxima Nova\", sans-serif;\n              position: relative;\n              top: -10px;\n              left: 0px;\n            }\n            span {\n              font-size: 14px;\n            }\n\n            span.badge {\n              margin: 0 4px 4px 0;\n              white-space: normal;\n            }\n\n            .astm-badge.custom-badge {\n              font-family: \"Proxima Nova\", sans-serif;\n              font-weight: 500;\n              white-space: normal;\n            }\n\n            span.blue-color {\n              color: #005da4;\n              line-height: 16px;\n            }\n            button.btn.show-more-txt {\n              margin: 0;\n              padding: 0;\n              border: 0;\n              border-radius: 0;\n              font-size: 14px;\n              color: #005da4;\n            }\n\n            a {\n              display: flex;\n              font-size: 14px;\n              margin-bottom: 16px;\n\n              svg {\n                height: 18px;\n                flex: 0 0 16px;\n                margin-right: 10px;\n              }\n\n              &:hover {\n                text-decoration: none;\n              }\n\n              &:last-child {\n                margin-bottom: 0px;\n              }\n            }\n          }\n\n          .doc-info.flyover-item {\n            & > span {\n              background: #232f3a;\n              display: inline-block;\n              color: #fff;\n              border-radius: 0.25rem;\n              padding: 0.25em 0.4em;\n              font-family: Proxima Nova Bold, sans-serif;\n              font-size: 12px !important;\n              letter-spacing: 1px;\n            }\n          }\n\n          &:last-child {\n            margin-bottom: 0;\n          }\n        }\n      }\n    }\n\n    .card-body.doc-log-wrapper {\n      padding: 0;\n\n      ul {\n        list-style: none;\n        margin: 0;\n        padding: 0;\n\n        li {\n          padding: 1.25rem;\n          border-bottom: 1px solid #ddd;\n\n          p.year-info {\n            // color: $color-system-gray-35;\n            font-weight: bold;\n          }\n\n          p {\n            line-height: 17px;\n          }\n\n          &:last-child {\n            border: 0;\n          }\n        }\n      }\n    }\n  }\n}\n// document info (Right panel) all documents list screen\n\n.tooltip.bs-tooltip-end .tooltip-inner::before {\n  left: -13px;\n  top: 50%;\n  transform: translateY(-50%);\n  border-top: 8px solid transparent;\n  border-bottom: 8px solid transparent;\n  border-right: 8px solid #303030;\n}\n.tooltip.bs-tooltip-end {\n  left: 5px !important;\n}\n\n#Committee::-webkit-scrollbar-track,\n#LetterBallotNumber::-webkit-scrollbar-track {\n  // -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);\n  border-radius: 4px;\n  background-color: #fff;\n}\n\n#Committee::-webkit-scrollbar,\n#LetterBallotNumber::-webkit-scrollbar {\n  width: 5px;\n  background-color: #cccccc;\n}\n\n#Committee::-webkit-scrollbar-thumb,\n#LetterBallotNumber::-webkit-scrollbar-thumb {\n  border-radius: 4px;\n  // -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);\n  background-color: #cfcfcf;\n}\n\n.list-group {\n  .card.astm-card {\n    border: 0 !important;\n  }\n}\n\n.custom-flex .form-check-label {\n  position: relative;\n  top: 2px;\n}\n\n.doc-info.remove-active {\n  .dropdown {\n    cursor: default;\n  }\n  button.btn {\n    cursor: default;\n  }\n  .dropdown-toggle::after {\n    display: none;\n  }\n  .astm-link:focus,\n  .btn:focus,\n  button:focus {\n    outline: none !important;\n    box-shadow: none !important;\n  }\n}\n\n// Permission pages css start ==========================================================\n\n.permission-wrapper {\n  text-align: center;\n  margin-top: 64px;\n\n  p {\n    color: #71777f;\n    font-size: 16px;\n  }\n\n  h4 {\n    font-size: 24px;\n    color: #71777f;\n  }\n}\n\n// Toast Message Css ============================\n.astm-alert.top-toster {\n  position: fixed !important;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 9999;\n  & > button {\n    border: 0;\n  }\n  .top-toser-ic {\n    position: absolute;\n    left: 18px;\n    top: 10px;\n    display: inline-block;\n    width: 20px;\n  }\n}\n\n.astm-alert.bg-success--light.top-toster::before {\n  opacity: 0;\n}\n// Alert Dismissible Toaster Css ============================\n\n.btn-close {\n  display: none;\n}\n\n.flex-box.toast-flex-box.alert-dismissible-toaster {\n  display: flex;\n  padding-left: 25px;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  .btn-close {\n    display: none;\n  }\n  .astm-alert-text {\n    padding-left: 0;\n  }\n\n  span {\n    line-height: 18px;\n  }\n}\n\n.alert-success {\n  .toster-inline-view {\n    display: flex;\n    flex-wrap: wrap;\n    margin: 0;\n    padding: 0 0 0 25px;\n    li {\n      margin-right: 10px;\n      font-size: 14px;\n      list-style: none;\n      position: relative;\n      line-height: 16px;\n      padding-left: 10px;\n      &:first-child {\n        padding-left: 0;\n      }\n      &::before {\n        content: \"\";\n        position: absolute;\n        left: 0px;\n        top: 6px;\n        width: 5px;\n        height: 5px;\n        border-radius: 100%;\n        background: #386c38;\n      }\n\n      &:first-child::before {\n        display: none;\n      }\n    }\n  }\n}\n\n.toster-inline-view {\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0;\n  padding: 0 0 0 25px;\n  li {\n    margin-right: 10px;\n    font-size: 14px;\n    list-style: none;\n    position: relative;\n    line-height: 16px;\n    padding-left: 10px;\n    &:first-child {\n      padding-left: 0;\n    }\n    &::before {\n      content: \"\";\n      position: absolute;\n      left: 0px;\n      top: 6px;\n      width: 5px;\n      height: 5px;\n      border-radius: 100%;\n      background: #841b24;\n    }\n\n    &:first-child::before {\n      display: none;\n    }\n  }\n}\n\n.astm-alert .close.custom-close-btn {\n  position: absolute;\n  top: 20px;\n  right: 35px;\n  & > span {\n    font-size: 24px;\n  }\n}\n\n// Alert Dismissible Toaster Css End ============================\n\n// Toast Message Css End ============================\n\n// Alert Dismissible Toaster Css ============================\n.btn-close {\n  display: none;\n}\n\n.flex-box.toast-flex-box.alert-dismissible-toaster {\n  display: flex;\n  padding-left: 25px;\n\n  .btn-close {\n    display: none;\n  }\n\n  .astm-alert-text {\n    padding-left: 0;\n  }\n  span {\n    line-height: 18px;\n  }\n}\n\n.astm-alert .close.custom-close-btn {\n  position: absolute;\n  top: 20px;\n  right: 35px;\n\n  & > span {\n    font-size: 24px;\n  }\n}\n\n// Alert Dismissible Toaster Css End ============================\n\n.input-prefix-text {\n  position: absolute;\n  top: 25px;\n  background: rgba(35, 47, 58, 0.06);\n  padding: 10px 11px;\n  left: 16px;\n  width: 50px;\n  border-right: 1px solid rgb(221, 221, 221);\n}\n\n#WorkItemNumber {\n  padding-left: 58px;\n}\n\n.ballot-detail-wrapper {\n  .top-header {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 24px;\n    position: absolute;\n    width: calc(100% - 41px);\n    background: #fff;\n    padding-bottom: 10px;\n    top: 20px;\n    left: 25px;\n    z-index: 9;\n  }\n\n  .top-left-sec {\n    display: flex;\n    align-items: center;\n\n    .zip-txt {\n      font-size: 14px;\n      color: #71777f;\n      margin: 0;\n      padding-left: 8px;\n    }\n\n    .back-btn {\n      margin-right: 16px;\n    }\n    .ballot-numb {\n      font-size: 24px;\n      color: #232f3a;\n      line-height: 32px;\n      font-family: Proxima Nova, sans-serif;\n\n      & > span {\n        font-size: 24px;\n        color: #232f3a;\n        margin-right: 10px;\n        display: inline-block;\n        line-height: 32px;\n        font-family: Proxima Nova, sans-serif;\n      }\n    }\n  }\n\n  .ballot-table-wrapper {\n    table {\n      margin-bottom: 0;\n      .slide-icons {\n        position: absolute;\n        top: -4px;\n        left: -30px;\n      }\n    }\n    margin-top: 70px;\n\n    .action-icons {\n      a.showReplaceIocnZip {\n        opacity: 0.2;\n        background: transparent;\n\n        &:hover {\n          opacity: 0.2;\n          background: transparent;\n        }\n      }\n      a.active {\n        opacity: 1;\n        background: rgba(35, 47, 58, 0.06);\n        color: #101010;\n        text-decoration: none;\n      }\n    }\n\n    .remove-first-col {\n      tr {\n        th:nth-child(1),\n        td:nth-child(1) {\n          display: none;\n        }\n        th:nth-child(2),\n        th:nth-child(3),\n        td:nth-child(2),\n        td:nth-child(3) {\n          width: 45%;\n        }\n      }\n      .showReplaceIocn {\n        display: flex;\n        transform: rotateZ(-90deg);\n        opacity: 0.4;\n      }\n    }\n\n    table {\n      thead {\n        tr {\n          th:nth-child(1) {\n            width: 5%;\n          }\n          th:nth-child(2) {\n            width: 51%;\n          }\n          th:nth-child(3) {\n            width: 32%;\n          }\n          th:nth-child(4) {\n            width: 22%;\n          }\n        }\n      }\n      tbody {\n        tr {\n          td:nth-child(1) {\n            width: 5%;\n            text-align: center;\n            svg {\n              position: relative;\n              cursor: pointer;\n            }\n            svg.remove-hand-ic {\n              cursor: default;\n            }\n          }\n          td:nth-child(2) {\n            width: 51%;\n          }\n          td:nth-child(3) {\n            width: 32%;\n          }\n          td:nth-child(4) {\n            width: 22%;\n          }\n        }\n      }\n    }\n\n    .td-col-one {\n      display: flex;\n      justify-content: space-between;\n      width: 370px;\n\n      .doc-name {\n        width: calc(100% - 60px);\n        word-wrap: break-word;\n        padding-right: 20px;\n        line-height: 20px;\n        font-family: \"Proxima Nova\", sans-serif;\n      }\n\n      .pdf-word-ic {\n        position: relative;\n        width: 60px;\n        display: inline-block;\n        height: 30px;\n        top: -5px;\n\n        svg {\n          width: 14px;\n        }\n      }\n      .flyover-Wrapper {\n        display: flex;\n        width: 100px;\n\n        .flyover-flag {\n          background: #232f3a;\n          width: 18px;\n          height: 19px;\n          color: #ffff;\n          border-radius: 3px;\n          font-size: 14px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          font-family: Proxima Nova Bold, sans-serif;\n          margin-bottom: 4px;\n          position: relative;\n          top: 1px;\n          margin-left: 8px;\n\n          &:last-child {\n            margin-bottom: 0;\n          }\n        }\n        .flyover-grey-light-flag {\n          background: #dddddd;\n          width: 18px;\n          height: 19px;\n          color: #232f3a;\n          border-radius: 3px;\n          font-size: 15px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          font-family: Proxima Nova Bold, sans-serif;\n          margin-bottom: 4px;\n          margin-left: 8px;\n          position: relative;\n          top: 1px;\n\n          &:last-child {\n            margin-bottom: 0;\n          }\n        }\n      }\n    }\n    .action-icons {\n      display: flex;\n      align-items: center;\n      justify-content: flex-end;\n      text-align: center;\n      position: relative;\n      top: -4px;\n\n      .replac-doc-ic {\n        display: none;\n        transform: rotateZ(-90deg);\n      }\n      .showReplaceIocn {\n        display: flex;\n        transform: rotateZ(-90deg);\n      }\n\n      a {\n        opacity: 0.5;\n        color: #232f3a;\n        width: 30px;\n        height: 30px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        border-radius: 4px;\n\n        &:hover {\n          opacity: 1;\n          background: rgba(35, 47, 58, 0.06);\n          color: #101010;\n          text-decoration: none;\n        }\n      }\n    }\n  }\n}\n\n.ballot-detail-wrapper.failed-panel-wrapper {\n  .ballot-table-wrapper {\n    margin-top: 0;\n    height: 100vh;\n  }\n}\n.showReplaceIocnZip {\n  display: flex;\n  transform: rotateZ(-90deg);\n  opacity: 0.4;\n  &:hover {\n    opacity: 0.4;\n    background: transparent;\n  }\n}\n\n.badge.zip-txt {\n  font-size: 14px;\n  color: #71777f;\n  margin: 0;\n  padding-left: 8px;\n  font-weight: normal;\n}\n.badge.zip-progess-txt {\n  font-size: 14px;\n  color: #7e6417;\n  margin: 0;\n  padding-left: 8px;\n  font-weight: normal;\n  padding-bottom: 0;\n  padding-top: 0;\n  font-family: \"Proxima Nova\", sans-serif;\n}\n.badge.zip-txt.zip-progres-wrapper {\n  font-weight: 300;\n  margin-left: 16px;\n}\n.no-result-txt {\n  text-align: center;\n  padding: 60px;\n  color: #71777f;\n  font-family: Proxima Nova, sans-serif;\n}\n\n.dismiss-toaster-wrapper {\n  position: absolute;\n  top: 0px;\n  width: 100%;\n\n  & > .astm-alert.top-toster {\n    position: relative !important;\n    margin-bottom: 0;\n  }\n}\n\n// Litigation Pages Css Start ==========================================================\n.modal-dialog.modal-dialog-centered.apply-litigation-wrapper {\n  max-width: 600px;\n  top: -14px;\n}\n.apply-litigation-wrapper {\n  font-family: \"Proxima Nova\", sans-serif;\n  .rbt-token {\n    background-color: #f4f4f5;\n    color: #232f3a;\n  }\n  .rbt-input-multi.form-control.rbt-input {\n    input.rbt-input-main {\n      padding: 0.25rem 0.5rem !important;\n    }\n  }\n\n  .custom-input-box {\n    position: relative;\n    input {\n      position: absolute;\n      top: -3px;\n    }\n    i {\n      position: absolute;\n      left: 255px;\n      top: 0;\n    }\n    .astm-custom-radio {\n      label::before {\n        content: \"\";\n        background: #fff;\n        width: 15px;\n        height: 15px;\n        display: inline-block;\n        border-radius: 100%;\n        border: #adb5bd solid 1px;\n        position: absolute;\n        top: 0px;\n        left: -1px;\n      }\n    }\n    .astm-custom-radio.active.form-check {\n      label::after {\n        content: \"\";\n        display: inline-block;\n        border: 1px solid #005da4;\n        background-color: #005da4;\n        position: absolute;\n        z-index: 1;\n        width: 15px;\n        height: 15px;\n        border-radius: 100%;\n        left: -1px;\n        top: 0px;\n      }\n      label::before {\n        background: #fff;\n        width: 5px;\n        height: 5px;\n        content: \"\";\n        display: inline-block;\n        z-index: 2;\n        border-radius: 100%;\n        top: 5px;\n        left: 4px;\n        border: 0;\n      }\n    }\n  }\n}\n\n.litigation-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: absolute;\n  width: calc(100% - 41px);\n  background: #fff;\n  top: 20px;\n  left: 25px;\n  padding: 0 0 15px 0;\n  z-index: 1;\n\n  .search-ballot-box {\n    position: relative;\n    position: relative;\n    width: 400px;\n    height: 38px;\n    & > input {\n      width: 100%;\n      min-width: 400px;\n      max-width: 100%;\n      padding-right: 30px;\n    }\n    .search-ic {\n      position: absolute;\n      right: 15px;\n      top: 10px;\n    }\n  }\n}\n.litigation-table-panel {\n  .table-filter-listing {\n    margin-top: 50px;\n    .table {\n      th:nth-child(5),\n      td:nth-child(5) {\n        width: 20%;\n        font-family: \"Proxima Nova\", sans-serif;\n      }\n      th:nth-child(2),\n      td:nth-child(2) {\n        width: 28%;\n        font-family: \"Proxima Nova\", sans-serif;\n      }\n      th:nth-child(2) {\n        i {\n          display: none;\n        }\n      }\n      th:nth-child(1),\n      th:nth-child(3),\n      th:nth-child(4) {\n        display: table-cell;\n        width: 14%;\n        font-family: \"Proxima Nova\", sans-serif;\n      }\n      td:nth-child(1),\n      td:nth-child(3),\n      td:nth-child(4),\n      td:nth-child(5) {\n        display: table-cell;\n        width: 15%;\n        font-family: \"Proxima Nova\", sans-serif;\n      }\n    }\n  }\n}\n.action-icons {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  text-align: center;\n  position: relative;\n  top: -4px;\n  a {\n    opacity: 0.5;\n    color: #232f3a;\n    width: 30px;\n    height: 30px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 4px;\n\n    i {\n      cursor: pointer;\n      height: 30px;\n      width: 30px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n    &:hover {\n      opacity: 1;\n      background: rgba(35, 47, 58, 0.06);\n      color: #101010;\n      text-decoration: none;\n    }\n  }\n}\n.d-flex {\n  display: flex;\n}\n.datepickerDV .react-datepicker__input-container input.error.is-invalid {\n  border: solid 1px #dc3545;\n}\n.display-none {\n  display: none;\n}\n.custom-toggle-Infomation {\n  .link-btn {\n    margin-left: 4px;\n    color: #005da4;\n    cursor: pointer;\n    position: relative;\n  }\n  .number-col {\n    position: relative;\n    display: inline-block;\n  }\n  .show-info-col {\n    position: absolute;\n    background: #fff;\n    width: 260px;\n    padding: 10px;\n    border: 1px solid #dddddd;\n    top: 25px;\n    z-index: 99;\n    color: #232f3a;\n    line-height: 20px;\n    left: -125px;\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: -6px;\n      z-index: 11;\n      display: block;\n      border-top: 1px solid #ddd;\n      border-left: 1px solid #ddd;\n      width: 10px;\n      transform: rotate(45deg);\n      height: 10px;\n      background: #fff;\n      left: 50%;\n    }\n  }\n}\n\n.astm-table.table-striped tbody tr:last-child,\n.astm-table.table-striped tbody tr:nth-last-child(2),\n.astm-table.table-striped tbody tr:nth-last-child(3),\n.astm-table.table-striped tbody tr:nth-last-child(4) {\n  .custom-toggle-Infomation {\n    .show-info-col {\n      top: auto;\n      bottom: 28px;\n      &::before {\n        transform: rotate(226deg);\n        top: auto;\n        bottom: -6px;\n      }\n    }\n    .show-info-col.custom-increase-width {\n      &::before {\n        left: 23%;\n      }\n    }\n  }\n}\n\n.astm-table.table-striped tbody tr:first-child,\n.astm-table.table-striped tbody tr:nth-child(2) {\n  .custom-toggle-Infomation {\n    .show-info-col {\n      bottom: auto;\n      top: 28px;\n      &::before {\n        transform: rotate(46deg);\n        bottom: auto;\n        top: -6px;\n      }\n    }\n    .show-info-col.custom-increase-width {\n      &::before {\n        left: 23%;\n      }\n    }\n  }\n}\n\n.custom-toggle-Infomation .show-info-col.custom-increase-width::before {\n  left: 23%;\n}\n\n.show-info-col.custom-increase-width {\n  width: 600px;\n}\n\n// Litigation Pages Css End ==========================================================\n\n.react-datepicker__input-container input:disabled,\n.react-datepicker__input-container input[readonly] {\n  background-color: #e9ecef;\n  opacity: 1;\n}\n.disable-close-ic {\n  opacity: 0.3;\n}\n\ntable.vote-attachments-table-wrapper {\n  .showReplaceIocn.disable-ic {\n    opacity: 0.3;\n    pointer-events: none;\n  }\n}\n.bulk-delete-head {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  .document-count {\n    font-size: 16px;\n    color: #232f3a;\n    font-family: Proxima Nova, sans-serif;\n    & > span {\n      display: inline-block;\n      margin-right: 9px;\n    }\n    .close-btn {\n      color: rgb(35 47 58 / 51%);\n      margin-left: 16px;\n      cursor: pointer;\n      position: relative;\n      top: 1px;\n      &:hover {\n        color: #232f3a;\n      }\n    }\n  }\n  .btn-outline-danger {\n    color: #941f29;\n    border-color: #941f29;\n  }\n  .btn-outline-danger:hover {\n    background: #f4f4f5;\n    color: #941f29;\n    border-color: #941f29;\n  }\n}\n.remove-bulk-delete-sec {\n  display: none;\n}\n.committee-COS-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 18px;\n  font-size: 14px;\n  font-family: Proxima Nova Bold, sans-serif;\n  color: #ffff;\n  margin-left: 10px;\n  background-color: #232f3a; \n  border-radius: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
